import { ApolloClient } from "@apollo/client/core";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date (isoformat) */
  Date: any;
  /** Date with time (isoformat) */
  DateTime: any;
  /** Decimal (fixed-point) */
  Decimal: any;
  /** Time (isoformat) */
  Time: any;
};


export type AddScheduleSlotError = {
  __typename?: 'AddScheduleSlotError';
  message: Scalars['String'];
};

export type AddScheduleSlotErrorDay = AddScheduleSlotError | Day;

export type AlreadySubscribed = {
  __typename?: 'AlreadySubscribed';
  message: Scalars['String'];
};

export type Answer = {
  __typename?: 'Answer';
  answer: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
};

export type AnswerInput = {
  answer: Scalars['String'];
  question: Scalars['ID'];
  options?: Maybe<Array<Scalars['ID']>>;
};

export type AttendeeTicket = {
  __typename?: 'AttendeeTicket';
  id: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
  item: TicketItem;
};

export type AudienceLevel = {
  __typename?: 'AudienceLevel';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BlogPostAuthor = {
  __typename?: 'BlogPostAuthor';
  id: Scalars['ID'];
  fullName: Scalars['String'];
};

export type BookScheduleItemResult = ScheduleItem | ScheduleItemIsFull | UserNeedsConferenceTicket | UserIsAlreadyBooked | ScheduleItemNotBookable;

export type CancelBookingScheduleItemResult = ScheduleItem | UserIsNotBooked | ScheduleItemNotBookable;

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  stripeSessionId: Scalars['String'];
};

export type Conference = {
  __typename?: 'Conference';
  id: Scalars['ID'];
  name: Scalars['String'];
  introduction: Scalars['String'];
  code: Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  map?: Maybe<Map>;
  pretixEventUrl: Scalars['String'];
  voucher?: Maybe<Voucher>;
  timezone: Scalars['String'];
  tickets: Array<TicketItem>;
  hotelRooms: Array<HotelRoom>;
  deadlines: Array<Deadline>;
  isCFPOpen: Scalars['Boolean'];
  isVotingOpen: Scalars['Boolean'];
  isVotingClosed: Scalars['Boolean'];
  deadline?: Maybe<Deadline>;
  audienceLevels: Array<AudienceLevel>;
  topics: Array<Topic>;
  languages: Array<Language>;
  durations: Array<Duration>;
  submissionTypes: Array<SubmissionType>;
  submissions?: Maybe<Array<Submission>>;
  events: Array<Event>;
  faqs: Array<Faq>;
  sponsorsByLevel: Array<SponsorsByLevel>;
  copy?: Maybe<Scalars['String']>;
  menu?: Maybe<Menu>;
  keynotes: Array<Keynote>;
  keynote?: Maybe<Keynote>;
  talks: Array<ScheduleItem>;
  talk?: Maybe<ScheduleItem>;
  ranking?: Maybe<RankRequest>;
  days: Array<Day>;
  isRunning: Scalars['Boolean'];
};


export type ConferenceNameArgs = {
  language?: Maybe<Scalars['String']>;
};


export type ConferenceIntroductionArgs = {
  language?: Maybe<Scalars['String']>;
};


export type ConferenceVoucherArgs = {
  code: Scalars['String'];
};


export type ConferenceTicketsArgs = {
  language: Scalars['String'];
  showUnavailableTickets?: Scalars['Boolean'];
};


export type ConferenceDeadlineArgs = {
  type: Scalars['String'];
};


export type ConferenceCopyArgs = {
  key: Scalars['String'];
  language?: Maybe<Scalars['String']>;
};


export type ConferenceMenuArgs = {
  identifier: Scalars['String'];
};


export type ConferenceKeynoteArgs = {
  slug: Scalars['String'];
};


export type ConferenceTalkArgs = {
  slug: Scalars['String'];
};


export type ConferenceRankingArgs = {
  topic: Scalars['ID'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type CreateOrderHotelRoom = {
  roomId: Scalars['String'];
  checkin: Scalars['Date'];
  checkout: Scalars['Date'];
};

export type CreateOrderInput = {
  email: Scalars['String'];
  locale: Scalars['String'];
  paymentProvider: Scalars['String'];
  invoiceInformation: InvoiceInformation;
  tickets: Array<CreateOrderTicket>;
  hotelRooms: Array<CreateOrderHotelRoom>;
};

export type CreateOrderResult = {
  __typename?: 'CreateOrderResult';
  paymentUrl: Scalars['String'];
};

export type CreateOrderResultError = CreateOrderResult | Error;

export type CreateOrderTicket = {
  ticketId: Scalars['String'];
  attendeeName: Scalars['String'];
  attendeeEmail: Scalars['String'];
  variation?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<CreateOrderTicketAnswer>>;
  voucher?: Maybe<Scalars['String']>;
};

export type CreateOrderTicketAnswer = {
  questionId: Scalars['String'];
  value: Scalars['String'];
};

export type CustomerPortalResponse = {
  __typename?: 'CustomerPortalResponse';
  billingPortalUrl: Scalars['String'];
};

export type CustomerPortalResult = CustomerPortalResponse | NoSubscription | NotSubscribedViaStripe;



export type Day = {
  __typename?: 'Day';
  day: Scalars['Date'];
  slots: Array<ScheduleSlot>;
  runningEvents: Array<ScheduleItem>;
  rooms: Array<DayRoom>;
};


export type DaySlotsArgs = {
  room?: Maybe<Scalars['ID']>;
};

export type DayRoom = {
  __typename?: 'DayRoom';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
  streamingUrl: Scalars['String'];
  slidoUrl: Scalars['String'];
};

export type Deadline = {
  __typename?: 'Deadline';
  id: Scalars['ID'];
  type: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  conference: Conference;
  status: DeadlineStatus;
};


export type DeadlineNameArgs = {
  language?: Maybe<Scalars['String']>;
};


export type DeadlineDescriptionArgs = {
  language?: Maybe<Scalars['String']>;
};

export enum DeadlineStatus {
  InTheFuture = 'IN_THE_FUTURE',
  HappeningNow = 'HAPPENING_NOW',
  InThePast = 'IN_THE_PAST'
}


export type Duration = {
  __typename?: 'Duration';
  id: Scalars['ID'];
  conference: Conference;
  name: Scalars['String'];
  duration: Scalars['Int'];
  notes: Scalars['String'];
  allowedSubmissionTypes: Array<SubmissionType>;
};

export type EmailAlreadyUsed = {
  __typename?: 'EmailAlreadyUsed';
  message: Scalars['String'];
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String'];
};

export type Event = {
  __typename?: 'Event';
  id: Scalars['ID'];
  conference: Conference;
  title: Scalars['String'];
  slug: Scalars['String'];
  content: Scalars['String'];
  map?: Maybe<Map>;
  image?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
};


export type EventTitleArgs = {
  language?: Maybe<Scalars['String']>;
};


export type EventSlugArgs = {
  language?: Maybe<Scalars['String']>;
};


export type EventContentArgs = {
  language?: Maybe<Scalars['String']>;
};

export type Faq = {
  __typename?: 'FAQ';
  id: Scalars['ID'];
  question: Scalars['String'];
  answer: Scalars['String'];
};


export type FaqQuestionArgs = {
  language?: Maybe<Scalars['String']>;
};


export type FaqAnswerArgs = {
  language?: Maybe<Scalars['String']>;
};

export type FieldError = {
  __typename?: 'FieldError';
  message: Scalars['String'];
  type: Scalars['String'];
};

export type GrantRequest = {
  __typename?: 'GrantRequest';
  id: Scalars['ID'];
};

export type HotelRoom = {
  __typename?: 'HotelRoom';
  id: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  price: Scalars['String'];
  isSoldOut: Scalars['Boolean'];
  capacityLeft: Scalars['Int'];
};


export type HotelRoomNameArgs = {
  language?: Maybe<Scalars['String']>;
};


export type HotelRoomDescriptionArgs = {
  language?: Maybe<Scalars['String']>;
};

export type InvoiceInformation = {
  isBusiness: Scalars['Boolean'];
  company?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  street: Scalars['String'];
  zipcode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  vatId: Scalars['String'];
  fiscalCode: Scalars['String'];
};

export type JobListing = {
  __typename?: 'JobListing';
  id: Scalars['ID'];
  title: Scalars['String'];
  slug: Scalars['String'];
  description: Scalars['String'];
  company: Scalars['String'];
  applyUrl: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
};


export type JobListingTitleArgs = {
  language?: Maybe<Scalars['String']>;
};


export type JobListingSlugArgs = {
  language?: Maybe<Scalars['String']>;
};


export type JobListingDescriptionArgs = {
  language?: Maybe<Scalars['String']>;
};

export type Keynote = {
  __typename?: 'Keynote';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  slug: Scalars['String'];
  topic?: Maybe<Topic>;
  speakers: Array<KeynoteSpeaker>;
};


export type KeynoteTitleArgs = {
  language?: Maybe<Scalars['String']>;
};


export type KeynoteDescriptionArgs = {
  language?: Maybe<Scalars['String']>;
};


export type KeynoteSlugArgs = {
  language?: Maybe<Scalars['String']>;
};

export type KeynoteSpeaker = {
  __typename?: 'KeynoteSpeaker';
  id: Scalars['ID'];
  name: Scalars['String'];
  bio: Scalars['String'];
  pronouns: Scalars['String'];
  twitterHandle: Scalars['String'];
  instagramHandle: Scalars['String'];
  website: Scalars['String'];
  highlightColor: Scalars['String'];
  photo: Scalars['String'];
};


export type KeynoteSpeakerBioArgs = {
  language?: Maybe<Scalars['String']>;
};


export type KeynoteSpeakerPronounsArgs = {
  language?: Maybe<Scalars['String']>;
};

export type Language = {
  __typename?: 'Language';
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
};

export type LoginErrors = {
  __typename?: 'LoginErrors';
  email?: Maybe<Array<FieldError>>;
  password?: Maybe<Array<FieldError>>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginResult = LoginSuccess | WrongEmailOrPassword | LoginValidationError;

export type LoginSuccess = {
  __typename?: 'LoginSuccess';
  user: User;
};

export type LoginValidationError = {
  __typename?: 'LoginValidationError';
  errors: LoginErrors;
};

export type Map = {
  __typename?: 'Map';
  id: Scalars['ID'];
  latitude: Scalars['Decimal'];
  longitude: Scalars['Decimal'];
  link?: Maybe<Scalars['String']>;
  image: Scalars['String'];
};


export type MapImageArgs = {
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  zoom?: Maybe<Scalars['Int']>;
};

export type Menu = {
  __typename?: 'Menu';
  title: Scalars['String'];
  links: Array<MenuLink>;
};


export type MenuTitleArgs = {
  language?: Maybe<Scalars['String']>;
};

export type MenuLink = {
  __typename?: 'MenuLink';
  href: Scalars['String'];
  title: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  page?: Maybe<Page>;
};


export type MenuLinkHrefArgs = {
  language?: Maybe<Scalars['String']>;
};


export type MenuLinkTitleArgs = {
  language?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  login: LoginResult;
  register: RegisterResult;
  requestResetPassword: RequestResetPasswordResult;
  resetPassword: ResetPasswordResult;
  updateProfile: UpdateProfileResult;
  sendSubmission: SendSubmissionOutput;
  updateSubmission: UpdateSubmissionOutput;
  sendSubmissionComment: SendSubmissionCommentOutput;
  sendVote: SendVoteOutput;
  createOrder: CreateOrderResultError;
  sendGrantRequest: SendGrantRequestOutput;
  subscribeToNewsletter: SubscribeToNewsletterOutput;
  unsubscribeToNewsletter: UnsubscribeToNewsletterOutput;
  bookScheduleItem: BookScheduleItemResult;
  cancelBookingScheduleItem: CancelBookingScheduleItemResult;
  updateScheduleInvitation: ScheduleInvitationNotFoundScheduleInvitation;
  addScheduleSlot: AddScheduleSlotErrorDay;
  updateOrCreateSlotItem: UpdateOrCreateSlotItemErrorUpdateOrCreateSlotItemResult;
  updateAttendeeTicket: UpdateAttendeeTicketResult;
  registerVolunteerDevice: Scalars['Boolean'];
  logout: Scalars['String'];
  subscribeUserToAssociation: SubscribeUserResult;
  manageUserSubscription: CustomerPortalResult;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRequestResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationSendSubmissionArgs = {
  input: SendSubmissionInput;
};


export type MutationUpdateSubmissionArgs = {
  input: UpdateSubmissionInput;
};


export type MutationSendSubmissionCommentArgs = {
  input: SendSubmissionCommentInput;
};


export type MutationSendVoteArgs = {
  input: SendVoteInput;
};


export type MutationCreateOrderArgs = {
  conference: Scalars['String'];
  input: CreateOrderInput;
};


export type MutationSendGrantRequestArgs = {
  input: SendGrantRequestInput;
};


export type MutationSubscribeToNewsletterArgs = {
  input: SubscribeToNewsletterInput;
};


export type MutationUnsubscribeToNewsletterArgs = {
  input: UnsubscribeToNewsletterInput;
};


export type MutationBookScheduleItemArgs = {
  id: Scalars['ID'];
};


export type MutationCancelBookingScheduleItemArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateScheduleInvitationArgs = {
  input: UpdateScheduleInvitationInput;
};


export type MutationAddScheduleSlotArgs = {
  conference: Scalars['ID'];
  duration: Scalars['Int'];
  day: Scalars['Date'];
};


export type MutationUpdateOrCreateSlotItemArgs = {
  input: UpdateOrCreateSlotItemInput;
};


export type MutationUpdateAttendeeTicketArgs = {
  conference: Scalars['String'];
  input: UpdateAttendeeTicketInput;
  language?: Scalars['String'];
};


export type MutationRegisterVolunteerDeviceArgs = {
  deviceToken: Scalars['String'];
  platform: Platform;
};

export type NewsletterSubscribeResult = {
  __typename?: 'NewsletterSubscribeResult';
  status: NewsletterSubscriptionResult;
};

export enum NewsletterSubscriptionResult {
  Subscribed = 'SUBSCRIBED',
  WaitingConfirmation = 'WAITING_CONFIRMATION',
  UnableToSubscribe = 'UNABLE_TO_SUBSCRIBE'
}

export type NoSubscription = {
  __typename?: 'NoSubscription';
  message: Scalars['String'];
};

export type NotSubscribedViaStripe = {
  __typename?: 'NotSubscribedViaStripe';
  message: Scalars['String'];
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID'];
  title: Scalars['String'];
  body: Scalars['String'];
  sentAt: Scalars['DateTime'];
};

export type OperationResult = {
  __typename?: 'OperationResult';
  ok: Scalars['Boolean'];
};

export type OperationSuccess = {
  __typename?: 'OperationSuccess';
  ok: Scalars['Boolean'];
};

export type Option = {
  __typename?: 'Option';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Page = {
  __typename?: 'Page';
  id: Scalars['ID'];
  title: Scalars['String'];
  slug: Scalars['String'];
  content: Scalars['String'];
  excerpt?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};


export type PageTitleArgs = {
  language?: Maybe<Scalars['String']>;
};


export type PageSlugArgs = {
  language?: Maybe<Scalars['String']>;
};


export type PageContentArgs = {
  language?: Maybe<Scalars['String']>;
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Post = {
  __typename?: 'Post';
  id: Scalars['ID'];
  author: BlogPostAuthor;
  title: Scalars['String'];
  slug: Scalars['String'];
  excerpt: Scalars['String'];
  content: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  published: Scalars['DateTime'];
};


export type PostTitleArgs = {
  language?: Maybe<Scalars['String']>;
};


export type PostSlugArgs = {
  language?: Maybe<Scalars['String']>;
};


export type PostExcerptArgs = {
  language?: Maybe<Scalars['String']>;
};


export type PostContentArgs = {
  language?: Maybe<Scalars['String']>;
};

export type PretixOrder = {
  __typename?: 'PretixOrder';
  code: Scalars['String'];
  status: PretixOrderStatus;
  total: Scalars['String'];
  url: Scalars['String'];
  email: Scalars['String'];
};

export enum PretixOrderStatus {
  Pending = 'PENDING',
  Paid = 'PAID',
  Expired = 'EXPIRED',
  Canceled = 'CANCELED'
}

export type ProductVariation = {
  __typename?: 'ProductVariation';
  id: Scalars['ID'];
  value: Scalars['String'];
  description: Scalars['String'];
  active: Scalars['Boolean'];
  defaultPrice: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  me: User;
  conference: Conference;
  blogPosts: Array<Post>;
  blogPost?: Maybe<Post>;
  submission?: Maybe<Submission>;
  submissions?: Maybe<Array<Submission>>;
  submissionTags: Array<SubmissionTag>;
  pages: Array<Page>;
  page?: Maybe<Page>;
  countries: Array<Country>;
  country: Country;
  order?: Maybe<PretixOrder>;
  jobListings: Array<JobListing>;
  jobListing?: Maybe<JobListing>;
  scheduleInvitation?: Maybe<ScheduleInvitation>;
  notifications: Array<Notification>;
  checklist: Array<ChecklistItem>;
  logout: Scalars['String'];
  associationService: Scalars['Boolean'];
};


export type QueryConferenceArgs = {
  code: Scalars['String'];
};


export type QueryBlogPostArgs = {
  slug: Scalars['String'];
};


export type QuerySubmissionArgs = {
  id: Scalars['ID'];
};


export type QuerySubmissionsArgs = {
  code: Scalars['String'];
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryPagesArgs = {
  code: Scalars['String'];
};


export type QueryPageArgs = {
  code: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryCountryArgs = {
  code?: Scalars['String'];
};


export type QueryOrderArgs = {
  conferenceCode: Scalars['String'];
  code: Scalars['String'];
};


export type QueryJobListingArgs = {
  slug: Scalars['String'];
};


export type QueryScheduleInvitationArgs = {
  submissionId: Scalars['ID'];
};

export type Question = {
  __typename?: 'Question';
  id: Scalars['ID'];
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Option>>;
  answer?: Maybe<Answer>;
};

export type RankRequest = {
  __typename?: 'RankRequest';
  isPublic: Scalars['Boolean'];
  rankedSubmissions: Array<RankSubmission>;
  stats: Array<RankStat>;
};

export type RankStat = {
  __typename?: 'RankStat';
  id: Scalars['ID'];
  type: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['Int'];
};

export type RankSubmission = {
  __typename?: 'RankSubmission';
  submission: Submission;
  rank: Scalars['Int'];
  score: Scalars['Decimal'];
};

export type RegisterErrors = {
  __typename?: 'RegisterErrors';
  email?: Maybe<Array<FieldError>>;
  password?: Maybe<Array<FieldError>>;
};

export type RegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type RegisterResult = RegisterSuccess | EmailAlreadyUsed | RegisterValidationError;

export type RegisterSuccess = {
  __typename?: 'RegisterSuccess';
  user: User;
};

export type RegisterValidationError = {
  __typename?: 'RegisterValidationError';
  errors: RegisterErrors;
};

export type RequestResetPasswordResult = OperationSuccess;

export type ResetPasswordErrors = {
  __typename?: 'ResetPasswordErrors';
  token?: Maybe<Array<FieldError>>;
  newPassword?: Maybe<Array<FieldError>>;
};

export type ResetPasswordInput = {
  token: Scalars['String'];
  newPassword: Scalars['String'];
};

export type ResetPasswordResult = ResetPasswordValidationError | OperationSuccess | ResetPasswordTokenExpired | ResetPasswordTokenInvalid;

export type ResetPasswordTokenExpired = {
  __typename?: 'ResetPasswordTokenExpired';
  message: Scalars['String'];
};

export type ResetPasswordTokenInvalid = {
  __typename?: 'ResetPasswordTokenInvalid';
  message: Scalars['String'];
};

export type ResetPasswordValidationError = {
  __typename?: 'ResetPasswordValidationError';
  errors: ResetPasswordErrors;
};

export type Room = {
  __typename?: 'Room';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ScheduleInvitation = {
  __typename?: 'ScheduleInvitation';
  id: Scalars['ID'];
  option: ScheduleInvitationOption;
  notes: Scalars['String'];
  submission: Submission;
  dates: Array<ScheduleInvitationDate>;
};

export type ScheduleInvitationDate = {
  __typename?: 'ScheduleInvitationDate';
  id: Scalars['ID'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
};

export type ScheduleInvitationNotFound = {
  __typename?: 'ScheduleInvitationNotFound';
  message: Scalars['String'];
};

export type ScheduleInvitationNotFoundScheduleInvitation = ScheduleInvitationNotFound | ScheduleInvitation;

export enum ScheduleInvitationOption {
  NoAnswer = 'NO_ANSWER',
  Confirm = 'CONFIRM',
  Maybe = 'MAYBE',
  Reject = 'REJECT',
  CantAttend = 'CANT_ATTEND'
}

export type ScheduleItem = {
  __typename?: 'ScheduleItem';
  id: Scalars['ID'];
  conference: Conference;
  title: Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  submission?: Maybe<Submission>;
  slug: Scalars['String'];
  description: Scalars['String'];
  type: Scalars['String'];
  duration?: Maybe<Scalars['Int']>;
  highlightColor?: Maybe<Scalars['String']>;
  language: Language;
  audienceLevel?: Maybe<AudienceLevel>;
  hasLimitedCapacity: Scalars['Boolean'];
  hasSpacesLeft: Scalars['Boolean'];
  spacesLeft: Scalars['Int'];
  userHasSpot: Scalars['Boolean'];
  speakers: Array<ScheduleItemUserScheduleItemNamedUser>;
  keynote?: Maybe<Keynote>;
  rooms: Array<Room>;
  image?: Maybe<Scalars['String']>;
  slidoUrl: Scalars['String'];
};

export type ScheduleItemIsFull = {
  __typename?: 'ScheduleItemIsFull';
  message: Scalars['String'];
};

export type ScheduleItemNamedUser = {
  __typename?: 'ScheduleItemNamedUser';
  fullName: Scalars['String'];
};

export type ScheduleItemNotBookable = {
  __typename?: 'ScheduleItemNotBookable';
  message: Scalars['String'];
};

export type ScheduleItemUser = {
  __typename?: 'ScheduleItemUser';
  id: Scalars['ID'];
  fullName: Scalars['String'];
};

export type ScheduleItemUserScheduleItemNamedUser = ScheduleItemUser | ScheduleItemNamedUser;

export type ScheduleSlot = {
  __typename?: 'ScheduleSlot';
  hour: Scalars['Time'];
  duration: Scalars['Int'];
  type: ScheduleSlotType;
  id: Scalars['ID'];
  items: Array<ScheduleItem>;
};

export enum ScheduleSlotType {
  Default = 'DEFAULT',
  FreeTime = 'FREE_TIME'
}

export type SendGrantRequestErrors = {
  __typename?: 'SendGrantRequestErrors';
  name: Array<Scalars['String']>;
  fullName: Array<Scalars['String']>;
  conference: Array<Scalars['String']>;
  email: Array<Scalars['String']>;
  age: Array<Scalars['String']>;
  gender: Array<Scalars['String']>;
  occupation: Array<Scalars['String']>;
  grantType: Array<Scalars['String']>;
  pythonUsage: Array<Scalars['String']>;
  beenToOtherEvents: Array<Scalars['String']>;
  interestedInVolunteering: Array<Scalars['String']>;
  needsFundsForTravel: Array<Scalars['String']>;
  why: Array<Scalars['String']>;
  notes: Array<Scalars['String']>;
  travellingFrom: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
};

export type SendGrantRequestInput = {
  name: Scalars['String'];
  fullName: Scalars['String'];
  conference: Scalars['ID'];
  email: Scalars['String'];
  age: Scalars['Int'];
  gender?: Maybe<Scalars['String']>;
  occupation: Scalars['String'];
  grantType: Scalars['String'];
  pythonUsage: Scalars['String'];
  beenToOtherEvents: Scalars['String'];
  interestedInVolunteering: Scalars['String'];
  needsFundsForTravel: Scalars['Boolean'];
  why: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  travellingFrom: Scalars['String'];
};

/** Output */
export type SendGrantRequestOutput = SendGrantRequestErrors | GrantRequest;

export type SendSubmissionCommentErrors = {
  __typename?: 'SendSubmissionCommentErrors';
  text: Array<Scalars['String']>;
  submission: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
};

export type SendSubmissionCommentInput = {
  text: Scalars['String'];
  submission: Scalars['ID'];
};

/** Output */
export type SendSubmissionCommentOutput = SendSubmissionCommentErrors | SubmissionComment;

export type SendSubmissionErrors = {
  __typename?: 'SendSubmissionErrors';
  title: Array<Scalars['String']>;
  abstract: Array<Scalars['String']>;
  topic: Array<Scalars['String']>;
  languages: Array<Scalars['String']>;
  conference: Array<Scalars['String']>;
  type: Array<Scalars['String']>;
  duration: Array<Scalars['String']>;
  elevatorPitch: Array<Scalars['String']>;
  notes: Array<Scalars['String']>;
  audienceLevel: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  speakerLevel: Array<Scalars['String']>;
  previousTalkVideo: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
};

export type SendSubmissionInput = {
  title: Scalars['String'];
  abstract: Scalars['String'];
  topic: Scalars['ID'];
  languages: Array<Scalars['ID']>;
  conference: Scalars['ID'];
  type: Scalars['ID'];
  duration: Scalars['ID'];
  elevatorPitch?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  audienceLevel: Scalars['ID'];
  tags?: Maybe<Array<Scalars['ID']>>;
  speakerLevel: Scalars['String'];
  previousTalkVideo?: Maybe<Scalars['String']>;
};

/** Output */
export type SendSubmissionOutput = SendSubmissionErrors | Submission;

export type SendVoteErrors = {
  __typename?: 'SendVoteErrors';
  submission: Array<Scalars['String']>;
  value: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
};

export type SendVoteInput = {
  submission: Scalars['ID'];
  value: Scalars['Int'];
};

/** Output */
export type SendVoteOutput = SendVoteErrors | VoteType;

export type Sponsor = {
  __typename?: 'Sponsor';
  id: Scalars['ID'];
  name: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export type SponsorsByLevel = {
  __typename?: 'SponsorsByLevel';
  level: Scalars['String'];
  sponsors: Array<Sponsor>;
  highlightColor?: Maybe<Scalars['String']>;
};

export type Submission = {
  __typename?: 'Submission';
  conference: Conference;
  title: Scalars['String'];
  slug: Scalars['String'];
  status: Scalars['String'];
  elevatorPitch?: Maybe<Scalars['String']>;
  abstract?: Maybe<Scalars['String']>;
  speakerLevel?: Maybe<Scalars['String']>;
  previousTalkVideo?: Maybe<Scalars['String']>;
  topic?: Maybe<Topic>;
  type?: Maybe<SubmissionType>;
  duration?: Maybe<Duration>;
  audienceLevel?: Maybe<AudienceLevel>;
  notes?: Maybe<Scalars['String']>;
  speaker?: Maybe<SubmissionSpeaker>;
  id: Scalars['ID'];
  canEdit: Scalars['Boolean'];
  comments: Array<SubmissionComment>;
  myVote?: Maybe<VoteType>;
  languages?: Maybe<Array<Language>>;
  tags?: Maybe<Array<SubmissionTag>>;
};

export type SubmissionComment = {
  __typename?: 'SubmissionComment';
  id: Scalars['ID'];
  text: Scalars['String'];
  created: Scalars['DateTime'];
  author: SubmissionCommentAuthor;
  submission: Submission;
};

export type SubmissionCommentAuthor = {
  __typename?: 'SubmissionCommentAuthor';
  id: Scalars['ID'];
  isSpeaker: Scalars['Boolean'];
  name: Scalars['String'];
};

export type SubmissionSpeaker = {
  __typename?: 'SubmissionSpeaker';
  id: Scalars['ID'];
  fullName: Scalars['String'];
  gender: Scalars['String'];
};

export type SubmissionTag = {
  __typename?: 'SubmissionTag';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SubmissionType = {
  __typename?: 'SubmissionType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SubscribeToNewsletterErrors = {
  __typename?: 'SubscribeToNewsletterErrors';
  email: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
};

export type SubscribeToNewsletterInput = {
  email: Scalars['String'];
};

/** Output */
export type SubscribeToNewsletterOutput = SubscribeToNewsletterErrors | NewsletterSubscribeResult;

export type SubscribeUserResult = CheckoutSession | AlreadySubscribed;

export type TicketItem = {
  __typename?: 'TicketItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  admission: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  defaultPrice?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  categoryInternalName?: Maybe<Scalars['String']>;
  taxRate?: Maybe<Scalars['Float']>;
  variations?: Maybe<Array<ProductVariation>>;
  availableFrom?: Maybe<Scalars['String']>;
  availableUntil?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Question>>;
  quantityLeft?: Maybe<Scalars['Int']>;
  type?: Maybe<TicketType>;
  soldOut?: Maybe<Scalars['Boolean']>;
};

export type TicketReassigned = {
  __typename?: 'TicketReassigned';
  id: Scalars['ID'];
  email: Scalars['String'];
};

export enum TicketType {
  Standard = 'STANDARD',
  Business = 'BUSINESS',
  Association = 'ASSOCIATION',
  Hotel = 'HOTEL'
}


export type Topic = {
  __typename?: 'Topic';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UnsubscribeToNewsletterErrors = {
  __typename?: 'UnsubscribeToNewsletterErrors';
  email: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
};

export type UnsubscribeToNewsletterInput = {
  email: Scalars['String'];
};

/** Output */
export type UnsubscribeToNewsletterOutput = UnsubscribeToNewsletterErrors | OperationResult;

export type UpdateAttendeeTicketError = {
  __typename?: 'UpdateAttendeeTicketError';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type UpdateAttendeeTicketErrors = {
  __typename?: 'UpdateAttendeeTicketErrors';
  id: Scalars['ID'];
  errors: Array<UpdateAttendeeTicketError>;
};

export type UpdateAttendeeTicketInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
  answers?: Maybe<Array<AnswerInput>>;
};

export type UpdateAttendeeTicketResult = TicketReassigned | AttendeeTicket | UpdateAttendeeTicketErrors;

export type UpdateOrCreateSlotItemError = {
  __typename?: 'UpdateOrCreateSlotItemError';
  message: Scalars['String'];
};

export type UpdateOrCreateSlotItemErrorUpdateOrCreateSlotItemResult = UpdateOrCreateSlotItemError | UpdateOrCreateSlotItemResult;

export type UpdateOrCreateSlotItemInput = {
  slotId: Scalars['ID'];
  rooms: Array<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['ID']>;
  keynoteId?: Maybe<Scalars['ID']>;
  submissionId?: Maybe<Scalars['ID']>;
};

export type UpdateOrCreateSlotItemResult = {
  __typename?: 'UpdateOrCreateSlotItemResult';
  updatedSlots: Array<ScheduleSlot>;
};

export type UpdateProfileErrors = {
  __typename?: 'UpdateProfileErrors';
  name?: Maybe<Array<FieldError>>;
  fullName?: Maybe<Array<FieldError>>;
  gender?: Maybe<Array<FieldError>>;
  openToRecruiting?: Maybe<Array<FieldError>>;
  openToNewsletter?: Maybe<Array<FieldError>>;
  dateBirth?: Maybe<Array<FieldError>>;
  country?: Maybe<Array<FieldError>>;
};

export type UpdateProfileInput = {
  name: Scalars['String'];
  fullName: Scalars['String'];
  gender: Scalars['String'];
  openToRecruiting: Scalars['Boolean'];
  openToNewsletter: Scalars['Boolean'];
  country: Scalars['String'];
  dateBirth?: Maybe<Scalars['Date']>;
};

export type UpdateProfileResult = User | UpdateProfileValidationError;

export type UpdateProfileValidationError = {
  __typename?: 'UpdateProfileValidationError';
  errors: UpdateProfileErrors;
};

export type UpdateScheduleInvitationInput = {
  submissionId: Scalars['ID'];
  option: ScheduleInvitationOption;
  notes: Scalars['String'];
};

export type UpdateSubmissionErrors = {
  __typename?: 'UpdateSubmissionErrors';
  instance: Array<Scalars['String']>;
  title: Array<Scalars['String']>;
  abstract: Array<Scalars['String']>;
  topic: Array<Scalars['String']>;
  languages: Array<Scalars['String']>;
  type: Array<Scalars['String']>;
  duration: Array<Scalars['String']>;
  elevatorPitch: Array<Scalars['String']>;
  notes: Array<Scalars['String']>;
  audienceLevel: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  speakerLevel: Array<Scalars['String']>;
  previousTalkVideo: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
};

export type UpdateSubmissionInput = {
  instance: Scalars['ID'];
  title: Scalars['String'];
  abstract: Scalars['String'];
  topic: Scalars['ID'];
  languages: Array<Scalars['ID']>;
  type: Scalars['ID'];
  duration: Scalars['ID'];
  elevatorPitch?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  audienceLevel: Scalars['ID'];
  tags?: Maybe<Array<Scalars['ID']>>;
  speakerLevel: Scalars['String'];
  previousTalkVideo?: Maybe<Scalars['String']>;
};

/** Output */
export type UpdateSubmissionOutput = UpdateSubmissionErrors | Submission;

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  email: Scalars['String'];
  fullname: Scalars['String'];
  fullName: Scalars['String'];
  name: Scalars['String'];
  username: Scalars['String'];
  gender: Scalars['String'];
  openToRecruiting: Scalars['Boolean'];
  openToNewsletter: Scalars['Boolean'];
  dateBirth?: Maybe<Scalars['Date']>;
  country: Scalars['String'];
  isStaff: Scalars['Boolean'];
  orders: Array<PretixOrder>;
  tickets: Array<AttendeeTicket>;
  submissions: Array<Submission>;
  canEditSchedule: Scalars['Boolean'];
  isPythonItaliaMember: Scalars['Boolean'];
};


export type UserOrdersArgs = {
  conference: Scalars['String'];
};


export type UserTicketsArgs = {
  conference: Scalars['String'];
  language: Scalars['String'];
};


export type UserSubmissionsArgs = {
  conference: Scalars['String'];
};

export type UserIsAlreadyBooked = {
  __typename?: 'UserIsAlreadyBooked';
  message: Scalars['String'];
};

export type UserIsNotBooked = {
  __typename?: 'UserIsNotBooked';
  message: Scalars['String'];
};

export type UserNeedsConferenceTicket = {
  __typename?: 'UserNeedsConferenceTicket';
  message: Scalars['String'];
};

export type VoteType = {
  __typename?: 'VoteType';
  id: Scalars['ID'];
  value: Scalars['Int'];
  submission: Submission;
};

export type Voucher = {
  __typename?: 'Voucher';
  id: Scalars['ID'];
  code: Scalars['String'];
  validUntil?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
  items: Array<Scalars['ID']>;
  allItems: Scalars['Boolean'];
  redeemed: Scalars['Int'];
  maxUsages: Scalars['Int'];
  priceMode: Scalars['String'];
  variationId?: Maybe<Scalars['ID']>;
};

export type WrongEmailOrPassword = {
  __typename?: 'WrongEmailOrPassword';
  message: Scalars['String'];
};

export type CfpFormQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type CfpFormQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { durations: Array<(
      { __typename?: 'Duration' }
      & Pick<Duration, 'name' | 'id'>
      & { allowedSubmissionTypes: Array<(
        { __typename?: 'SubmissionType' }
        & Pick<SubmissionType, 'id' | 'name'>
      )> }
    )>, audienceLevels: Array<(
      { __typename?: 'AudienceLevel' }
      & Pick<AudienceLevel, 'id' | 'name'>
    )>, submissionTypes: Array<(
      { __typename?: 'SubmissionType' }
      & Pick<SubmissionType, 'id' | 'name'>
    )>, topics: Array<(
      { __typename?: 'Topic' }
      & Pick<Topic, 'id' | 'name'>
    )>, languages: Array<(
      { __typename?: 'Language' }
      & Pick<Language, 'code' | 'id' | 'name'>
    )> }
  ) }
);

export type SendSubmissionMutationVariables = Exact<{
  input: SendSubmissionInput;
}>;


export type SendSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { mutationOp: (
    { __typename: 'SendSubmissionErrors' }
    & Pick<SendSubmissionErrors, 'nonFieldErrors'>
    & { validationTitle: SendSubmissionErrors['title'], validationAbstract: SendSubmissionErrors['abstract'], validationTopic: SendSubmissionErrors['topic'], validationLanguages: SendSubmissionErrors['languages'], validationType: SendSubmissionErrors['type'], validationDuration: SendSubmissionErrors['duration'], validationElevatorPitch: SendSubmissionErrors['elevatorPitch'], validationNotes: SendSubmissionErrors['notes'], validationAudienceLevel: SendSubmissionErrors['audienceLevel'], validationTags: SendSubmissionErrors['tags'], validationPreviousTalkVideo: SendSubmissionErrors['previousTalkVideo'], validationSpeakerLevel: SendSubmissionErrors['speakerLevel'] }
  ) | (
    { __typename: 'Submission' }
    & Pick<Submission, 'id' | 'title'>
  ) }
);

export type FooterQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type FooterQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { menu?: Maybe<(
      { __typename?: 'Menu' }
      & { links: Array<(
        { __typename?: 'MenuLink' }
        & Pick<MenuLink, 'title' | 'href'>
      )> }
    )> }
  ) }
);

export type GrantDeadlineQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type GrantDeadlineQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { deadline?: Maybe<(
      { __typename?: 'Deadline' }
      & Pick<Deadline, 'id' | 'start' | 'end' | 'status'>
    )> }
  ) }
);

export type SendGrantRequestMutationVariables = Exact<{
  input: SendGrantRequestInput;
}>;


export type SendGrantRequestMutation = (
  { __typename?: 'Mutation' }
  & { sendGrantRequest: (
    { __typename: 'SendGrantRequestErrors' }
    & Pick<SendGrantRequestErrors, 'nonFieldErrors'>
    & { validationConference: SendGrantRequestErrors['conference'], validationEmail: SendGrantRequestErrors['email'], validationName: SendGrantRequestErrors['name'], validationFullName: SendGrantRequestErrors['fullName'], validationGender: SendGrantRequestErrors['gender'], validationGrantType: SendGrantRequestErrors['grantType'], validationOccupation: SendGrantRequestErrors['occupation'], validationAge: SendGrantRequestErrors['age'], validationPythonUsage: SendGrantRequestErrors['pythonUsage'], validationBeenToOtherEvents: SendGrantRequestErrors['beenToOtherEvents'], validationInterestedInVolunteering: SendGrantRequestErrors['interestedInVolunteering'], validationNeedsFundsForTravel: SendGrantRequestErrors['needsFundsForTravel'], validationWhy: SendGrantRequestErrors['why'], validationNotes: SendGrantRequestErrors['notes'], validationTravellingFrom: SendGrantRequestErrors['travellingFrom'] }
  ) | (
    { __typename: 'GrantRequest' }
    & Pick<GrantRequest, 'id'>
  ) }
);

export type HeaderQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type HeaderQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { conferenceMenuEn?: Maybe<(
      { __typename?: 'Menu' }
      & { links: Array<(
        { __typename?: 'MenuLink' }
        & Pick<MenuLink, 'title' | 'href'>
        & { page?: Maybe<(
          { __typename?: 'Page' }
          & Pick<Page, 'slug'>
        )> }
      )> }
    )>, programMenuEn?: Maybe<(
      { __typename?: 'Menu' }
      & { links: Array<(
        { __typename?: 'MenuLink' }
        & Pick<MenuLink, 'title' | 'href'>
        & { page?: Maybe<(
          { __typename?: 'Page' }
          & Pick<Page, 'slug'>
        )> }
      )> }
    )>, conferenceMenuIt?: Maybe<(
      { __typename?: 'Menu' }
      & { links: Array<(
        { __typename?: 'MenuLink' }
        & Pick<MenuLink, 'title' | 'href'>
        & { page?: Maybe<(
          { __typename?: 'Page' }
          & Pick<Page, 'slug'>
        )> }
      )> }
    )>, programMenuIt?: Maybe<(
      { __typename?: 'Menu' }
      & { links: Array<(
        { __typename?: 'MenuLink' }
        & Pick<MenuLink, 'title' | 'href'>
        & { page?: Maybe<(
          { __typename?: 'Page' }
          & Pick<Page, 'slug'>
        )> }
      )> }
    )> }
  ) }
);

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = (
  { __typename?: 'Query' }
  & { submissionTags: Array<(
    { __typename?: 'SubmissionTag' }
    & Pick<SubmissionTag, 'name' | 'id'>
  )> }
);

export type KeynotesSectionQueryVariables = Exact<{
  code: Scalars['String'];
  language: Scalars['String'];
}>;


export type KeynotesSectionQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { keynotes: Array<(
      { __typename?: 'Keynote' }
      & Pick<Keynote, 'id' | 'title' | 'slug'>
      & { speakers: Array<(
        { __typename?: 'KeynoteSpeaker' }
        & Pick<KeynoteSpeaker, 'id' | 'name' | 'photo' | 'highlightColor'>
      )> }
    )> }
  ) }
);

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login: (
    { __typename: 'LoginSuccess' }
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id'>
    ) }
  ) | { __typename: 'WrongEmailOrPassword' } | (
    { __typename: 'LoginValidationError' }
    & { errors: (
      { __typename?: 'LoginErrors' }
      & { email?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message' | 'type'>
      )>>, password?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message' | 'type'>
      )>> }
    ) }
  ) }
);

export type MapWithLinkQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type MapWithLinkQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { map?: Maybe<(
      { __typename?: 'Map' }
      & Pick<Map, 'id' | 'image' | 'link'>
    )> }
  ) }
);

export type SubscribeMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SubscribeMutation = (
  { __typename?: 'Mutation' }
  & { subscribeToNewsletter: (
    { __typename: 'SubscribeToNewsletterErrors' }
    & Pick<SubscribeToNewsletterErrors, 'nonFieldErrors'>
    & { validationEmail: SubscribeToNewsletterErrors['email'] }
  ) | (
    { __typename: 'NewsletterSubscribeResult' }
    & Pick<NewsletterSubscribeResult, 'status'>
  ) }
);

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type MySubmissionsQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type MySubmissionsQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { submissions: Array<(
      { __typename?: 'Submission' }
      & Pick<Submission, 'id' | 'title'>
      & { topic?: Maybe<(
        { __typename?: 'Topic' }
        & Pick<Topic, 'id' | 'name'>
      )>, audienceLevel?: Maybe<(
        { __typename?: 'AudienceLevel' }
        & Pick<AudienceLevel, 'id' | 'name'>
      )>, type?: Maybe<(
        { __typename?: 'SubmissionType' }
        & Pick<SubmissionType, 'id' | 'name'>
      )> }
    )> }
  ) }
);

export type UpdateTicketMutationVariables = Exact<{
  conference: Scalars['String'];
  input: UpdateAttendeeTicketInput;
  language: Scalars['String'];
}>;


export type UpdateTicketMutation = (
  { __typename: 'Mutation' }
  & { updateAttendeeTicket: (
    { __typename: 'TicketReassigned' }
    & Pick<TicketReassigned, 'id' | 'email'>
  ) | (
    { __typename: 'AttendeeTicket' }
    & Pick<AttendeeTicket, 'id' | 'name' | 'email'>
    & { item: (
      { __typename?: 'TicketItem' }
      & Pick<TicketItem, 'id' | 'name' | 'language' | 'description' | 'category'>
      & { questions?: Maybe<Array<(
        { __typename?: 'Question' }
        & Pick<Question, 'id' | 'name'>
        & { answer?: Maybe<(
          { __typename?: 'Answer' }
          & Pick<Answer, 'answer' | 'options'>
        )>, options?: Maybe<Array<(
          { __typename?: 'Option' }
          & Pick<Option, 'id' | 'name'>
        )>> }
      )>> }
    ) }
  ) | (
    { __typename: 'UpdateAttendeeTicketErrors' }
    & Pick<UpdateAttendeeTicketErrors, 'id'>
    & { errors: Array<(
      { __typename?: 'UpdateAttendeeTicketError' }
      & Pick<UpdateAttendeeTicketError, 'field' | 'message'>
    )> }
  ) }
);

export type SignupMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type SignupMutation = (
  { __typename?: 'Mutation' }
  & { register: (
    { __typename: 'RegisterSuccess' }
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email' | 'fullname' | 'name'>
    ) }
  ) | (
    { __typename: 'EmailAlreadyUsed' }
    & Pick<EmailAlreadyUsed, 'message'>
  ) | (
    { __typename: 'RegisterValidationError' }
    & { errors: (
      { __typename?: 'RegisterErrors' }
      & { email?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message' | 'type'>
      )>>, password?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message' | 'type'>
      )>> }
    ) }
  ) }
);

export type SendCommentMutationVariables = Exact<{
  input: SendSubmissionCommentInput;
}>;


export type SendCommentMutation = (
  { __typename?: 'Mutation' }
  & { sendSubmissionComment: (
    { __typename: 'SendSubmissionCommentErrors' }
    & Pick<SendSubmissionCommentErrors, 'nonFieldErrors'>
    & { validationText: SendSubmissionCommentErrors['text'], validationSubmission: SendSubmissionCommentErrors['submission'] }
  ) | (
    { __typename: 'SubmissionComment' }
    & Pick<SubmissionComment, 'id'>
    & { submission: (
      { __typename?: 'Submission' }
      & Pick<Submission, 'id'>
      & { comments: Array<(
        { __typename?: 'SubmissionComment' }
        & Pick<SubmissionComment, 'text' | 'id' | 'created'>
        & { author: (
          { __typename?: 'SubmissionCommentAuthor' }
          & Pick<SubmissionCommentAuthor, 'name'>
        ) }
      )> }
    ) }
  ) }
);

export type SubmissionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubmissionQuery = (
  { __typename?: 'Query' }
  & { submission?: Maybe<(
    { __typename?: 'Submission' }
    & Pick<Submission, 'id' | 'title' | 'abstract' | 'elevatorPitch' | 'notes' | 'canEdit'>
    & { topic?: Maybe<(
      { __typename?: 'Topic' }
      & Pick<Topic, 'id' | 'name'>
    )>, duration?: Maybe<(
      { __typename?: 'Duration' }
      & Pick<Duration, 'id' | 'name' | 'duration'>
    )>, audienceLevel?: Maybe<(
      { __typename?: 'AudienceLevel' }
      & Pick<AudienceLevel, 'id' | 'name'>
    )>, languages?: Maybe<Array<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>>, tags?: Maybe<Array<(
      { __typename?: 'SubmissionTag' }
      & Pick<SubmissionTag, 'id' | 'name'>
    )>>, comments: Array<(
      { __typename?: 'SubmissionComment' }
      & Pick<SubmissionComment, 'id' | 'text' | 'created'>
      & { author: (
        { __typename?: 'SubmissionCommentAuthor' }
        & Pick<SubmissionCommentAuthor, 'name'>
      ) }
    )> }
  )> }
);

export type CreateOrderMutationVariables = Exact<{
  conference: Scalars['String'];
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = (
  { __typename?: 'Mutation' }
  & { createOrder: (
    { __typename?: 'CreateOrderResult' }
    & Pick<CreateOrderResult, 'paymentUrl'>
  ) | (
    { __typename?: 'Error' }
    & Pick<Error, 'message'>
  ) }
);

export type GetVoucherQueryVariables = Exact<{
  conference: Scalars['String'];
  code: Scalars['String'];
}>;


export type GetVoucherQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { voucher?: Maybe<(
      { __typename?: 'Voucher' }
      & Pick<Voucher, 'id' | 'code' | 'value' | 'redeemed' | 'maxUsages' | 'priceMode' | 'items' | 'allItems' | 'variationId' | 'validUntil'>
    )> }
  ) }
);

export type SubmissionAccordionFragment = (
  { __typename?: 'Submission' }
  & Pick<Submission, 'id' | 'title' | 'elevatorPitch'>
  & { topic?: Maybe<(
    { __typename?: 'Topic' }
    & Pick<Topic, 'id' | 'name'>
  )>, tags?: Maybe<Array<(
    { __typename?: 'SubmissionTag' }
    & Pick<SubmissionTag, 'name' | 'id'>
  )>>, audienceLevel?: Maybe<(
    { __typename?: 'AudienceLevel' }
    & Pick<AudienceLevel, 'id' | 'name'>
  )>, duration?: Maybe<(
    { __typename?: 'Duration' }
    & Pick<Duration, 'id' | 'name' | 'duration'>
  )>, languages?: Maybe<Array<(
    { __typename?: 'Language' }
    & Pick<Language, 'id' | 'name' | 'code'>
  )>>, myVote?: Maybe<(
    { __typename?: 'VoteType' }
    & Pick<VoteType, 'id' | 'value'>
  )> }
);

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = (
  { __typename?: 'Query' }
  & { countries: Array<(
    { __typename?: 'Country' }
    & Pick<Country, 'code' | 'name'>
  )> }
);

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'name' | 'fullName' | 'email' | 'gender' | 'dateBirth' | 'country' | 'openToRecruiting' | 'openToNewsletter' | 'canEditSchedule' | 'isPythonItaliaMember'>
  ) }
);

export type PageQueryVariables = Exact<{
  code: Scalars['String'];
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type PageQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<(
    { __typename?: 'Page' }
    & Pick<Page, 'id' | 'title' | 'content' | 'image'>
  )> }
);

export type AllPagesQueryVariables = Exact<{
  code: Scalars['String'];
  language?: Maybe<Scalars['String']>;
}>;


export type AllPagesQuery = (
  { __typename?: 'Query' }
  & { pages: Array<(
    { __typename?: 'Page' }
    & Pick<Page, 'id' | 'slug'>
  )> }
);

export type PostQueryVariables = Exact<{
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type PostQuery = (
  { __typename?: 'Query' }
  & { blogPost?: Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'id' | 'title' | 'content' | 'excerpt' | 'published' | 'image'>
    & { author: (
      { __typename?: 'BlogPostAuthor' }
      & Pick<BlogPostAuthor, 'fullName'>
    ) }
  )> }
);

export type BlogSocialCardQueryVariables = Exact<{
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type BlogSocialCardQuery = (
  { __typename?: 'Query' }
  & { blogPost?: Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'id' | 'title'>
    & { author: (
      { __typename?: 'BlogPostAuthor' }
      & Pick<BlogPostAuthor, 'fullName'>
    ) }
  )> }
);

export type BlogIndexQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type BlogIndexQuery = (
  { __typename?: 'Query' }
  & { blogPosts: Array<(
    { __typename?: 'Post' }
    & Pick<Post, 'id' | 'slug' | 'title' | 'excerpt'>
  )> }
);

export type IsCfpOpenQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type IsCfpOpenQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id' | 'isCFPOpen'>
    & { cfpDeadline?: Maybe<(
      { __typename?: 'Deadline' }
      & Pick<Deadline, 'id' | 'end'>
    )> }
  ) }
);

export type MeSubmissionsQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type MeSubmissionsQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { submissions: Array<(
      { __typename?: 'Submission' }
      & Pick<Submission, 'id' | 'title'>
    )> }
  ) }
);

export type IndexPageQueryVariables = Exact<{
  code: Scalars['String'];
  language: Scalars['String'];
}>;


export type IndexPageQuery = (
  { __typename?: 'Query' }
  & { blogPosts: Array<(
    { __typename?: 'Post' }
    & Pick<Post, 'id' | 'slug' | 'title'>
  )>, conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id' | 'name' | 'introduction' | 'isRunning'>
    & { marquee: Conference['copy'], introTitle: Conference['copy'], introText: Conference['copy'], homepageSection1Title: Conference['copy'], homepageSection1Subtitle: Conference['copy'], homepageSection1Text: Conference['copy'], homepageSection1CTALink: Conference['copy'], homepageSection1CTAText: Conference['copy'], gettingThereText: Conference['copy'] }
    & { map?: Maybe<(
      { __typename?: 'Map' }
      & Pick<Map, 'id' | 'link'>
    )>, cfpDeadline?: Maybe<(
      { __typename?: 'Deadline' }
      & Pick<Deadline, 'id' | 'start' | 'end'>
    )>, votingDeadline?: Maybe<(
      { __typename?: 'Deadline' }
      & Pick<Deadline, 'id' | 'start' | 'end'>
    )>, faqs: Array<(
      { __typename?: 'FAQ' }
      & Pick<Faq, 'id' | 'question' | 'answer'>
    )>, events: Array<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'title' | 'locationName' | 'image' | 'start'>
    )>, sponsorsByLevel: Array<(
      { __typename?: 'SponsorsByLevel' }
      & Pick<SponsorsByLevel, 'level' | 'highlightColor'>
      & { sponsors: Array<(
        { __typename?: 'Sponsor' }
        & Pick<Sponsor, 'id' | 'name' | 'link' | 'image'>
      )> }
    )> }
  ) }
);

export type AllJobListingsQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type AllJobListingsQuery = (
  { __typename?: 'Query' }
  & { jobListings: Array<(
    { __typename?: 'JobListing' }
    & Pick<JobListing, 'id' | 'slug' | 'title' | 'description' | 'applyUrl' | 'company' | 'companyLogo'>
  )> }
);

export type KeynoteSocialCardQueryVariables = Exact<{
  conference: Scalars['String'];
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type KeynoteSocialCardQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { keynote?: Maybe<(
      { __typename?: 'Keynote' }
      & Pick<Keynote, 'id' | 'title'>
      & { speakers: Array<(
        { __typename?: 'KeynoteSpeaker' }
        & Pick<KeynoteSpeaker, 'id' | 'name'>
      )> }
    )> }
  ) }
);

export type AllKeynotesQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type AllKeynotesQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { keynotes: Array<(
      { __typename?: 'Keynote' }
      & Pick<Keynote, 'id' | 'slug'>
    )> }
  ) }
);

export type KeynoteQueryVariables = Exact<{
  conference: Scalars['String'];
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type KeynoteQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { keynote?: Maybe<(
      { __typename?: 'Keynote' }
      & Pick<Keynote, 'id' | 'title' | 'description' | 'slug'>
      & { topic?: Maybe<(
        { __typename?: 'Topic' }
        & Pick<Topic, 'id' | 'name'>
      )>, speakers: Array<(
        { __typename?: 'KeynoteSpeaker' }
        & Pick<KeynoteSpeaker, 'id' | 'name' | 'bio' | 'pronouns' | 'twitterHandle' | 'instagramHandle' | 'website' | 'photo' | 'highlightColor'>
      )> }
    )> }
  ) }
);

export type KeynotesPageQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type KeynotesPageQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { title: Conference['copy'], subtitle: Conference['copy'], description: Conference['copy'] }
    & { keynotes: Array<(
      { __typename?: 'Keynote' }
      & Pick<Keynote, 'id' | 'title' | 'slug'>
      & { speakers: Array<(
        { __typename?: 'KeynoteSpeaker' }
        & Pick<KeynoteSpeaker, 'id' | 'name' | 'photo' | 'highlightColor'>
      )> }
    )> }
  ) }
);

export type SocialLoginCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type SocialLoginCheckQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'email'>
  ) }
);

export type OrderQueryVariables = Exact<{
  conferenceCode: Scalars['String'];
  code: Scalars['String'];
}>;


export type OrderQuery = (
  { __typename?: 'Query' }
  & { order?: Maybe<(
    { __typename?: 'PretixOrder' }
    & Pick<PretixOrder, 'code' | 'status' | 'url'>
  )> }
);

export type MyEditProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEditProfileQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'email' | 'name' | 'fullName' | 'gender' | 'openToRecruiting' | 'openToNewsletter' | 'dateBirth' | 'country'>
  ) }
);

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateProfile: (
    { __typename: 'User' }
    & Pick<User, 'id' | 'name' | 'fullName' | 'gender' | 'openToRecruiting' | 'openToNewsletter' | 'country' | 'dateBirth'>
  ) | (
    { __typename: 'UpdateProfileValidationError' }
    & { errors: (
      { __typename?: 'UpdateProfileErrors' }
      & { name?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message'>
      )>>, dateBirth?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message'>
      )>>, fullName?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message'>
      )>>, gender?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message'>
      )>>, openToRecruiting?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message'>
      )>>, openToNewsletter?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message'>
      )>>, country?: Maybe<Array<(
        { __typename?: 'FieldError' }
        & Pick<FieldError, 'message'>
      )>> }
    ) }
  ) }
);

export type MyProfileQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type MyProfileQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'name' | 'fullName' | 'email' | 'gender' | 'dateBirth' | 'country' | 'openToRecruiting' | 'openToNewsletter'>
    & { submissions: Array<(
      { __typename?: 'Submission' }
      & Pick<Submission, 'id' | 'title' | 'slug'>
    )>, orders: Array<(
      { __typename?: 'PretixOrder' }
      & Pick<PretixOrder, 'code' | 'status' | 'url' | 'total'>
    )>, tickets: Array<(
      { __typename?: 'AttendeeTicket' }
      & Pick<AttendeeTicket, 'id' | 'name' | 'email'>
      & { item: (
        { __typename?: 'TicketItem' }
        & Pick<TicketItem, 'id' | 'name' | 'language' | 'description' | 'category' | 'admission'>
        & { questions?: Maybe<Array<(
          { __typename?: 'Question' }
          & Pick<Question, 'id' | 'name'>
          & { answer?: Maybe<(
            { __typename?: 'Answer' }
            & Pick<Answer, 'answer' | 'options'>
          )>, options?: Maybe<Array<(
            { __typename?: 'Option' }
            & Pick<Option, 'id' | 'name'>
          )>> }
        )>> }
      ) }
    )> }
  ) }
);

export type RankingQueryVariables = Exact<{
  conference: Scalars['String'];
  topic: Scalars['ID'];
}>;


export type RankingQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { ranking?: Maybe<(
      { __typename?: 'RankRequest' }
      & Pick<RankRequest, 'isPublic'>
      & { stats: Array<(
        { __typename?: 'RankStat' }
        & Pick<RankStat, 'id' | 'type' | 'value' | 'name'>
      )>, rankedSubmissions: Array<(
        { __typename?: 'RankSubmission' }
        & Pick<RankSubmission, 'rank' | 'score'>
        & { submission: (
          { __typename?: 'Submission' }
          & { speaker?: Maybe<(
            { __typename?: 'SubmissionSpeaker' }
            & Pick<SubmissionSpeaker, 'id' | 'fullName'>
          )> }
          & SubmissionAccordionFragment
        ) }
      )> }
    )> }
  ) }
);

export type TopicsQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type TopicsQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { topics: Array<(
      { __typename?: 'Topic' }
      & Pick<Topic, 'id' | 'name'>
    )> }
  ) }
);

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestPasswordResetMutation = (
  { __typename?: 'Mutation' }
  & { requestResetPassword: (
    { __typename: 'OperationSuccess' }
    & Pick<OperationSuccess, 'ok'>
  ) }
);

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword: { __typename: 'ResetPasswordValidationError' } | (
    { __typename: 'OperationSuccess' }
    & Pick<OperationSuccess, 'ok'>
  ) | { __typename: 'ResetPasswordTokenExpired' } | { __typename: 'ResetPasswordTokenInvalid' } }
);

export type AddScheduleSlotMutationVariables = Exact<{
  code: Scalars['ID'];
  day: Scalars['Date'];
  duration: Scalars['Int'];
}>;


export type AddScheduleSlotMutation = (
  { __typename?: 'Mutation' }
  & { addScheduleSlot: { __typename?: 'AddScheduleSlotError' } | (
    { __typename?: 'Day' }
    & Pick<Day, 'day'>
    & { slots: Array<(
      { __typename?: 'ScheduleSlot' }
      & ScheduleSlotFragmentFragment
    )> }
  ) }
);

export type KeynoteFragmentFragment = (
  { __typename?: 'Keynote' }
  & Pick<Keynote, 'id' | 'title' | 'slug'>
  & { speakers: Array<(
    { __typename?: 'KeynoteSpeaker' }
    & Pick<KeynoteSpeaker, 'id' | 'name' | 'photo' | 'highlightColor'>
  )> }
);

export type ScheduleSlotFragmentFragment = (
  { __typename?: 'ScheduleSlot' }
  & Pick<ScheduleSlot, 'id' | 'hour' | 'duration' | 'type'>
  & { items: Array<(
    { __typename?: 'ScheduleItem' }
    & Pick<ScheduleItem, 'id' | 'title' | 'slug' | 'type' | 'duration' | 'hasLimitedCapacity' | 'userHasSpot' | 'hasSpacesLeft' | 'spacesLeft'>
    & { audienceLevel?: Maybe<(
      { __typename?: 'AudienceLevel' }
      & Pick<AudienceLevel, 'name'>
    )>, language: (
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name' | 'code'>
    ), submission?: Maybe<(
      { __typename?: 'Submission' }
      & SubmissionFragmentFragment
    )>, keynote?: Maybe<(
      { __typename?: 'Keynote' }
      & KeynoteFragmentFragment
    )>, speakers: Array<(
      { __typename: 'ScheduleItemUser' }
      & Pick<ScheduleItemUser, 'id' | 'fullName'>
    ) | (
      { __typename: 'ScheduleItemNamedUser' }
      & Pick<ScheduleItemNamedUser, 'fullName'>
    )>, rooms: Array<(
      { __typename?: 'Room' }
      & Pick<Room, 'id' | 'name' | 'type'>
    )> }
  )> }
);

export type SubmissionFragmentFragment = (
  { __typename?: 'Submission' }
  & Pick<Submission, 'id' | 'title'>
  & { duration?: Maybe<(
    { __typename?: 'Duration' }
    & Pick<Duration, 'id' | 'duration'>
  )>, audienceLevel?: Maybe<(
    { __typename?: 'AudienceLevel' }
    & Pick<AudienceLevel, 'id' | 'name'>
  )>, speaker?: Maybe<(
    { __typename?: 'SubmissionSpeaker' }
    & Pick<SubmissionSpeaker, 'id' | 'fullName'>
  )>, type?: Maybe<(
    { __typename?: 'SubmissionType' }
    & Pick<SubmissionType, 'id' | 'name'>
  )> }
);

export type GetScheduleInvitationQueryVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type GetScheduleInvitationQuery = (
  { __typename?: 'Query' }
  & { scheduleInvitation?: Maybe<(
    { __typename?: 'ScheduleInvitation' }
    & Pick<ScheduleInvitation, 'id' | 'option' | 'notes'>
    & { submission: (
      { __typename?: 'Submission' }
      & Pick<Submission, 'id' | 'title'>
    ), dates: Array<(
      { __typename?: 'ScheduleInvitationDate' }
      & Pick<ScheduleInvitationDate, 'id' | 'start' | 'end'>
    )> }
  )> }
);

export type UpdateScheduleInvitationMutationVariables = Exact<{
  input: UpdateScheduleInvitationInput;
}>;


export type UpdateScheduleInvitationMutation = (
  { __typename?: 'Mutation' }
  & { updateScheduleInvitation: (
    { __typename: 'ScheduleInvitationNotFound' }
    & Pick<ScheduleInvitationNotFound, 'message'>
  ) | (
    { __typename: 'ScheduleInvitation' }
    & Pick<ScheduleInvitation, 'id' | 'option' | 'notes'>
  ) }
);

export type ScheduleDaysQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ScheduleDaysQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { days: Array<(
      { __typename?: 'Day' }
      & Pick<Day, 'day'>
    )> }
  ) }
);

export type ScheduleQueryVariables = Exact<{
  code: Scalars['String'];
  fetchSubmissions: Scalars['Boolean'];
}>;


export type ScheduleQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id' | 'timezone'>
    & { days: Array<(
      { __typename?: 'Day' }
      & Pick<Day, 'day'>
      & { rooms: Array<(
        { __typename?: 'DayRoom' }
        & Pick<DayRoom, 'id' | 'name' | 'type'>
      )>, slots: Array<(
        { __typename?: 'ScheduleSlot' }
        & ScheduleSlotFragmentFragment
      )> }
    )>, submissions?: Maybe<Array<(
      { __typename?: 'Submission' }
      & SubmissionFragmentFragment
    )>>, keynotes?: Maybe<Array<(
      { __typename?: 'Keynote' }
      & KeynoteFragmentFragment
    )>>, durations: Array<(
      { __typename?: 'Duration' }
      & Pick<Duration, 'id' | 'duration'>
      & { allowedSubmissionTypes: Array<(
        { __typename?: 'SubmissionType' }
        & Pick<SubmissionType, 'name'>
      )> }
    )> }
  ) }
);

export type UpdateOrCreateSlotItemMutationVariables = Exact<{
  input: UpdateOrCreateSlotItemInput;
}>;


export type UpdateOrCreateSlotItemMutation = (
  { __typename?: 'Mutation' }
  & { updateOrCreateSlotItem: { __typename?: 'UpdateOrCreateSlotItemError' } | (
    { __typename?: 'UpdateOrCreateSlotItemResult' }
    & { updatedSlots: Array<(
      { __typename?: 'ScheduleSlot' }
      & ScheduleSlotFragmentFragment
    )> }
  ) }
);

export type SocialCardQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SocialCardQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id' | 'start' | 'end' | 'name'>
  ) }
);

export type StreamingQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type StreamingQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id' | 'timezone'>
    & { days: Array<(
      { __typename?: 'Day' }
      & Pick<Day, 'day'>
      & { runningEvents: Array<(
        { __typename?: 'ScheduleItem' }
        & Pick<ScheduleItem, 'id' | 'slidoUrl' | 'duration' | 'title'>
        & { rooms: Array<(
          { __typename?: 'Room' }
          & Pick<Room, 'id' | 'name'>
        )> }
      )>, rooms: Array<(
        { __typename?: 'DayRoom' }
        & Pick<DayRoom, 'id' | 'name' | 'type' | 'streamingUrl' | 'slidoUrl'>
      )> }
    )> }
  ) }
);

export type GetSubmissionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSubmissionQuery = (
  { __typename?: 'Query' }
  & { submission?: Maybe<(
    { __typename?: 'Submission' }
    & Pick<Submission, 'id' | 'title' | 'abstract' | 'elevatorPitch' | 'notes' | 'canEdit' | 'speakerLevel' | 'previousTalkVideo'>
    & { type?: Maybe<(
      { __typename?: 'SubmissionType' }
      & Pick<SubmissionType, 'id' | 'name'>
    )>, topic?: Maybe<(
      { __typename?: 'Topic' }
      & Pick<Topic, 'id' | 'name'>
    )>, duration?: Maybe<(
      { __typename?: 'Duration' }
      & Pick<Duration, 'id' | 'name'>
    )>, audienceLevel?: Maybe<(
      { __typename?: 'AudienceLevel' }
      & Pick<AudienceLevel, 'id' | 'name'>
    )>, languages?: Maybe<Array<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'code' | 'name'>
    )>>, tags?: Maybe<Array<(
      { __typename?: 'SubmissionTag' }
      & Pick<SubmissionTag, 'id' | 'name'>
    )>> }
  )> }
);

export type UpdateSubmissionMutationVariables = Exact<{
  input: UpdateSubmissionInput;
}>;


export type UpdateSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { mutationOp: (
    { __typename: 'UpdateSubmissionErrors' }
    & Pick<UpdateSubmissionErrors, 'nonFieldErrors'>
    & { validationTitle: UpdateSubmissionErrors['title'], validationAbstract: UpdateSubmissionErrors['abstract'], validationTopic: UpdateSubmissionErrors['topic'], validationLanguages: UpdateSubmissionErrors['languages'], validationType: UpdateSubmissionErrors['type'], validationDuration: UpdateSubmissionErrors['duration'], validationElevatorPitch: UpdateSubmissionErrors['elevatorPitch'], validationNotes: UpdateSubmissionErrors['notes'], validationAudienceLevel: UpdateSubmissionErrors['audienceLevel'], validationTags: UpdateSubmissionErrors['tags'], validationPreviousTalkVideo: UpdateSubmissionErrors['previousTalkVideo'], validationSpeakerLevel: UpdateSubmissionErrors['speakerLevel'] }
  ) | (
    { __typename: 'Submission' }
    & Pick<Submission, 'id' | 'title' | 'abstract' | 'elevatorPitch' | 'notes' | 'speakerLevel' | 'previousTalkVideo'>
    & { type?: Maybe<(
      { __typename?: 'SubmissionType' }
      & Pick<SubmissionType, 'id' | 'name'>
    )>, topic?: Maybe<(
      { __typename?: 'Topic' }
      & Pick<Topic, 'id' | 'name'>
    )>, duration?: Maybe<(
      { __typename?: 'Duration' }
      & Pick<Duration, 'id' | 'name'>
    )>, audienceLevel?: Maybe<(
      { __typename?: 'AudienceLevel' }
      & Pick<AudienceLevel, 'id' | 'name'>
    )>, languages?: Maybe<Array<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'code' | 'name'>
    )>>, tags?: Maybe<Array<(
      { __typename?: 'SubmissionTag' }
      & Pick<SubmissionTag, 'id' | 'name'>
    )>> }
  ) }
);

export type IsVotingClosedQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type IsVotingClosedQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id' | 'isVotingClosed'>
  ) }
);

export type BookScheduleItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BookScheduleItemMutation = (
  { __typename?: 'Mutation' }
  & { bookScheduleItem: (
    { __typename: 'ScheduleItem' }
    & Pick<ScheduleItem, 'id' | 'userHasSpot' | 'spacesLeft' | 'hasSpacesLeft'>
  ) | { __typename: 'ScheduleItemIsFull' } | { __typename: 'UserNeedsConferenceTicket' } | { __typename: 'UserIsAlreadyBooked' } | { __typename: 'ScheduleItemNotBookable' } }
);

export type CancelBookingScheduleItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelBookingScheduleItemMutation = (
  { __typename?: 'Mutation' }
  & { cancelBookingScheduleItem: (
    { __typename: 'ScheduleItem' }
    & Pick<ScheduleItem, 'id' | 'userHasSpot' | 'hasSpacesLeft' | 'spacesLeft'>
  ) | { __typename: 'UserIsNotBooked' } | { __typename: 'ScheduleItemNotBookable' } }
);

export type TalkSocialCardQueryVariables = Exact<{
  slug: Scalars['String'];
  code: Scalars['String'];
}>;


export type TalkSocialCardQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { talk?: Maybe<(
      { __typename?: 'ScheduleItem' }
      & Pick<ScheduleItem, 'id' | 'title'>
      & { speakers: Array<(
        { __typename: 'ScheduleItemUser' }
        & Pick<ScheduleItemUser, 'id' | 'fullName'>
      ) | (
        { __typename: 'ScheduleItemNamedUser' }
        & Pick<ScheduleItemNamedUser, 'fullName'>
      )> }
    )> }
  ) }
);

export type TalkQueryVariables = Exact<{
  slug: Scalars['String'];
  code: Scalars['String'];
}>;


export type TalkQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { talk?: Maybe<(
      { __typename?: 'ScheduleItem' }
      & Pick<ScheduleItem, 'id' | 'title' | 'image' | 'highlightColor' | 'description' | 'hasLimitedCapacity' | 'spacesLeft' | 'hasSpacesLeft' | 'slidoUrl'>
      & { language: (
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      ), submission?: Maybe<(
        { __typename?: 'Submission' }
        & Pick<Submission, 'id' | 'abstract' | 'elevatorPitch'>
        & { duration?: Maybe<(
          { __typename?: 'Duration' }
          & Pick<Duration, 'id' | 'duration'>
        )>, audienceLevel?: Maybe<(
          { __typename?: 'AudienceLevel' }
          & Pick<AudienceLevel, 'id' | 'name'>
        )>, topic?: Maybe<(
          { __typename?: 'Topic' }
          & Pick<Topic, 'name'>
        )> }
      )>, speakers: Array<(
        { __typename?: 'ScheduleItemUser' }
        & Pick<ScheduleItemUser, 'id' | 'fullName'>
      ) | (
        { __typename?: 'ScheduleItemNamedUser' }
        & Pick<ScheduleItemNamedUser, 'fullName'>
      )> }
    )> }
  ) }
);

export type AllTalksQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type AllTalksQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { talks: Array<(
      { __typename?: 'ScheduleItem' }
      & Pick<ScheduleItem, 'id' | 'slug'>
    )> }
  ) }
);

export type WorkshopBookingStateQueryVariables = Exact<{
  slug: Scalars['String'];
  code: Scalars['String'];
}>;


export type WorkshopBookingStateQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id'>
    & { talk?: Maybe<(
      { __typename?: 'ScheduleItem' }
      & Pick<ScheduleItem, 'id' | 'hasLimitedCapacity' | 'spacesLeft' | 'hasSpacesLeft' | 'userHasSpot'>
    )> }
  ) }
);

export type TicketsQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type TicketsQuery = (
  { __typename?: 'Query' }
  & { conference: (
    { __typename?: 'Conference' }
    & Pick<Conference, 'id' | 'start' | 'end' | 'pretixEventUrl'>
    & { tickets: Array<(
      { __typename?: 'TicketItem' }
      & Pick<TicketItem, 'id' | 'language' | 'name' | 'description' | 'defaultPrice' | 'availableUntil' | 'quantityLeft' | 'type' | 'category' | 'taxRate' | 'admission'>
      & { variations?: Maybe<Array<(
        { __typename?: 'ProductVariation' }
        & Pick<ProductVariation, 'id' | 'defaultPrice' | 'value'>
      )>>, questions?: Maybe<Array<(
        { __typename?: 'Question' }
        & Pick<Question, 'id' | 'name' | 'required'>
        & { options?: Maybe<Array<(
          { __typename?: 'Option' }
          & Pick<Option, 'id' | 'name'>
        )>> }
      )>> }
    )>, hotelRooms: Array<(
      { __typename?: 'HotelRoom' }
      & Pick<HotelRoom, 'id' | 'name' | 'description' | 'price' | 'isSoldOut' | 'capacityLeft'>
    )> }
  ) }
);

export type SendVoteMutationVariables = Exact<{
  input: SendVoteInput;
}>;


export type SendVoteMutation = (
  { __typename?: 'Mutation' }
  & { sendVote: (
    { __typename: 'SendVoteErrors' }
    & Pick<SendVoteErrors, 'nonFieldErrors'>
    & { validationValue: SendVoteErrors['value'], validationSubmission: SendVoteErrors['submission'] }
  ) | (
    { __typename: 'VoteType' }
    & Pick<VoteType, 'id' | 'value'>
  ) }
);

export type VotingSubmissionsQueryVariables = Exact<{
  conference: Scalars['String'];
  after?: Maybe<Scalars['String']>;
  loadMore: Scalars['Boolean'];
}>;


export type VotingSubmissionsQuery = (
  { __typename?: 'Query' }
  & { conference?: Maybe<(
    { __typename?: 'Conference' }
    & Pick<Conference, 'id' | 'isVotingOpen'>
    & { votingDeadline?: Maybe<(
      { __typename?: 'Deadline' }
      & Pick<Deadline, 'id' | 'end'>
    )>, topics: Array<(
      { __typename?: 'Topic' }
      & Pick<Topic, 'id' | 'name'>
    )>, languages: Array<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name' | 'code'>
    )> }
  )>, submissions?: Maybe<Array<(
    { __typename?: 'Submission' }
    & SubmissionAccordionFragment
  )>>, submissionTags?: Maybe<Array<(
    { __typename?: 'SubmissionTag' }
    & Pick<SubmissionTag, 'id' | 'name'>
  )>> }
);

export const SubmissionAccordionFragmentDoc = gql`
    fragment submissionAccordion on Submission {
  id
  title
  elevatorPitch
  topic {
    id
    name
  }
  tags {
    name
    id
  }
  audienceLevel {
    id
    name
  }
  duration {
    id
    name
    duration
  }
  languages {
    id
    name
    code
  }
  myVote {
    id
    value
  }
}
    `;
export const SubmissionFragmentFragmentDoc = gql`
    fragment SubmissionFragment on Submission {
  id
  title
  duration {
    id
    duration
  }
  audienceLevel {
    id
    name
  }
  speaker {
    id
    fullName
  }
  type {
    id
    name
  }
}
    `;
export const KeynoteFragmentFragmentDoc = gql`
    fragment KeynoteFragment on Keynote {
  id
  title(language: "en")
  slug(language: "en")
  speakers {
    id
    name
    photo
    highlightColor
  }
}
    `;
export const ScheduleSlotFragmentFragmentDoc = gql`
    fragment ScheduleSlotFragment on ScheduleSlot {
  id
  hour
  duration
  type
  items {
    id
    title
    slug
    type
    duration
    hasLimitedCapacity
    userHasSpot
    hasSpacesLeft
    spacesLeft
    audienceLevel {
      name
    }
    language {
      id
      name
      code
    }
    submission {
      ...SubmissionFragment
    }
    keynote {
      ...KeynoteFragment
    }
    speakers {
      __typename
      ... on ScheduleItemUser {
        id
        fullName
      }
      ... on ScheduleItemNamedUser {
        fullName
      }
    }
    rooms {
      id
      name
      type
    }
  }
}
    ${SubmissionFragmentFragmentDoc}
${KeynoteFragmentFragmentDoc}`;
export const CfpFormDocument = gql`
    query CfpForm($conference: String!) {
  conference(code: $conference) {
    id
    durations {
      name
      id
      allowedSubmissionTypes {
        id
        name
      }
    }
    audienceLevels {
      id
      name
    }
    submissionTypes {
      id
      name
    }
    topics {
      id
      name
    }
    languages {
      code
      id
      name
    }
  }
}
    `;

/**
 * __useCfpFormQuery__
 *
 * To run a query within a React component, call `useCfpFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCfpFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCfpFormQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useCfpFormQuery(baseOptions: Apollo.QueryHookOptions<CfpFormQuery, CfpFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CfpFormQuery, CfpFormQueryVariables>(CfpFormDocument, options);
      }
export function useCfpFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CfpFormQuery, CfpFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CfpFormQuery, CfpFormQueryVariables>(CfpFormDocument, options);
        }
export type CfpFormQueryHookResult = ReturnType<typeof useCfpFormQuery>;
export type CfpFormLazyQueryHookResult = ReturnType<typeof useCfpFormLazyQuery>;
export type CfpFormQueryResult = Apollo.QueryResult<CfpFormQuery, CfpFormQueryVariables>;
export const SendSubmissionDocument = gql`
    mutation SendSubmission($input: SendSubmissionInput!) {
  mutationOp: sendSubmission(input: $input) {
    __typename
    ... on Submission {
      id
      title
    }
    ... on SendSubmissionErrors {
      validationTitle: title
      validationAbstract: abstract
      validationTopic: topic
      validationLanguages: languages
      validationType: type
      validationDuration: duration
      validationElevatorPitch: elevatorPitch
      validationNotes: notes
      validationAudienceLevel: audienceLevel
      validationTags: tags
      validationPreviousTalkVideo: previousTalkVideo
      validationSpeakerLevel: speakerLevel
      nonFieldErrors
    }
  }
}
    `;
export type SendSubmissionMutationFn = Apollo.MutationFunction<SendSubmissionMutation, SendSubmissionMutationVariables>;

/**
 * __useSendSubmissionMutation__
 *
 * To run a mutation, you first call `useSendSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSubmissionMutation, { data, loading, error }] = useSendSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<SendSubmissionMutation, SendSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSubmissionMutation, SendSubmissionMutationVariables>(SendSubmissionDocument, options);
      }
export type SendSubmissionMutationHookResult = ReturnType<typeof useSendSubmissionMutation>;
export type SendSubmissionMutationResult = Apollo.MutationResult<SendSubmissionMutation>;
export type SendSubmissionMutationOptions = Apollo.BaseMutationOptions<SendSubmissionMutation, SendSubmissionMutationVariables>;
export const FooterDocument = gql`
    query Footer($code: String!) {
  conference(code: $code) {
    id
    menu(identifier: "footer-nav") {
      links {
        title
        href
      }
    }
  }
}
    `;

/**
 * __useFooterQuery__
 *
 * To run a query within a React component, call `useFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useFooterQuery(baseOptions: Apollo.QueryHookOptions<FooterQuery, FooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FooterQuery, FooterQueryVariables>(FooterDocument, options);
      }
export function useFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FooterQuery, FooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FooterQuery, FooterQueryVariables>(FooterDocument, options);
        }
export type FooterQueryHookResult = ReturnType<typeof useFooterQuery>;
export type FooterLazyQueryHookResult = ReturnType<typeof useFooterLazyQuery>;
export type FooterQueryResult = Apollo.QueryResult<FooterQuery, FooterQueryVariables>;
export const GrantDeadlineDocument = gql`
    query GrantDeadline($conference: String!) {
  conference(code: $conference) {
    id
    deadline(type: "grants") {
      id
      start
      end
      status
    }
  }
}
    `;

/**
 * __useGrantDeadlineQuery__
 *
 * To run a query within a React component, call `useGrantDeadlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrantDeadlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrantDeadlineQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useGrantDeadlineQuery(baseOptions: Apollo.QueryHookOptions<GrantDeadlineQuery, GrantDeadlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrantDeadlineQuery, GrantDeadlineQueryVariables>(GrantDeadlineDocument, options);
      }
export function useGrantDeadlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrantDeadlineQuery, GrantDeadlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrantDeadlineQuery, GrantDeadlineQueryVariables>(GrantDeadlineDocument, options);
        }
export type GrantDeadlineQueryHookResult = ReturnType<typeof useGrantDeadlineQuery>;
export type GrantDeadlineLazyQueryHookResult = ReturnType<typeof useGrantDeadlineLazyQuery>;
export type GrantDeadlineQueryResult = Apollo.QueryResult<GrantDeadlineQuery, GrantDeadlineQueryVariables>;
export const SendGrantRequestDocument = gql`
    mutation SendGrantRequest($input: SendGrantRequestInput!) {
  sendGrantRequest(input: $input) {
    __typename
    ... on GrantRequest {
      id
    }
    ... on SendGrantRequestErrors {
      validationConference: conference
      validationEmail: email
      validationName: name
      validationFullName: fullName
      validationGender: gender
      validationGrantType: grantType
      validationOccupation: occupation
      validationOccupation: occupation
      validationAge: age
      validationPythonUsage: pythonUsage
      validationBeenToOtherEvents: beenToOtherEvents
      validationInterestedInVolunteering: interestedInVolunteering
      validationNeedsFundsForTravel: needsFundsForTravel
      validationWhy: why
      validationNotes: notes
      validationTravellingFrom: travellingFrom
      nonFieldErrors
    }
  }
}
    `;
export type SendGrantRequestMutationFn = Apollo.MutationFunction<SendGrantRequestMutation, SendGrantRequestMutationVariables>;

/**
 * __useSendGrantRequestMutation__
 *
 * To run a mutation, you first call `useSendGrantRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGrantRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGrantRequestMutation, { data, loading, error }] = useSendGrantRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendGrantRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendGrantRequestMutation, SendGrantRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGrantRequestMutation, SendGrantRequestMutationVariables>(SendGrantRequestDocument, options);
      }
export type SendGrantRequestMutationHookResult = ReturnType<typeof useSendGrantRequestMutation>;
export type SendGrantRequestMutationResult = Apollo.MutationResult<SendGrantRequestMutation>;
export type SendGrantRequestMutationOptions = Apollo.BaseMutationOptions<SendGrantRequestMutation, SendGrantRequestMutationVariables>;
export const HeaderDocument = gql`
    query Header($code: String!) {
  conference(code: $code) {
    id
    conferenceMenuEn: menu(identifier: "conference-nav") {
      links {
        title(language: "en")
        href(language: "en")
        page {
          slug(language: "en")
        }
      }
    }
    programMenuEn: menu(identifier: "program-nav") {
      links {
        title(language: "en")
        href(language: "en")
        page {
          slug(language: "en")
        }
      }
    }
    conferenceMenuIt: menu(identifier: "conference-nav") {
      links {
        title(language: "it")
        href(language: "it")
        page {
          slug(language: "it")
        }
      }
    }
    programMenuIt: menu(identifier: "program-nav") {
      links {
        title(language: "it")
        href(language: "it")
        page {
          slug(language: "it")
        }
      }
    }
  }
}
    `;

/**
 * __useHeaderQuery__
 *
 * To run a query within a React component, call `useHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useHeaderQuery(baseOptions: Apollo.QueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
      }
export function useHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
        }
export type HeaderQueryHookResult = ReturnType<typeof useHeaderQuery>;
export type HeaderLazyQueryHookResult = ReturnType<typeof useHeaderLazyQuery>;
export type HeaderQueryResult = Apollo.QueryResult<HeaderQuery, HeaderQueryVariables>;
export const TagsDocument = gql`
    query Tags {
  submissionTags {
    name
    id
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const KeynotesSectionDocument = gql`
    query KeynotesSection($code: String!, $language: String!) {
  conference(code: $code) {
    id
    keynotes {
      id
      title(language: $language)
      slug(language: $language)
      speakers {
        id
        name
        photo
        highlightColor
      }
    }
  }
}
    `;

/**
 * __useKeynotesSectionQuery__
 *
 * To run a query within a React component, call `useKeynotesSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeynotesSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeynotesSectionQuery({
 *   variables: {
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useKeynotesSectionQuery(baseOptions: Apollo.QueryHookOptions<KeynotesSectionQuery, KeynotesSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeynotesSectionQuery, KeynotesSectionQueryVariables>(KeynotesSectionDocument, options);
      }
export function useKeynotesSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeynotesSectionQuery, KeynotesSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeynotesSectionQuery, KeynotesSectionQueryVariables>(KeynotesSectionDocument, options);
        }
export type KeynotesSectionQueryHookResult = ReturnType<typeof useKeynotesSectionQuery>;
export type KeynotesSectionLazyQueryHookResult = ReturnType<typeof useKeynotesSectionLazyQuery>;
export type KeynotesSectionQueryResult = Apollo.QueryResult<KeynotesSectionQuery, KeynotesSectionQueryVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    __typename
    ... on LoginSuccess {
      user {
        id
      }
    }
    ... on LoginValidationError {
      errors {
        email {
          message
          type
        }
        password {
          message
          type
        }
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const MapWithLinkDocument = gql`
    query MapWithLink($code: String!) {
  conference(code: $code) {
    id
    map {
      id
      image(width: 1280, height: 400, zoom: 15)
      link
    }
  }
}
    `;

/**
 * __useMapWithLinkQuery__
 *
 * To run a query within a React component, call `useMapWithLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapWithLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapWithLinkQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useMapWithLinkQuery(baseOptions: Apollo.QueryHookOptions<MapWithLinkQuery, MapWithLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MapWithLinkQuery, MapWithLinkQueryVariables>(MapWithLinkDocument, options);
      }
export function useMapWithLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MapWithLinkQuery, MapWithLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MapWithLinkQuery, MapWithLinkQueryVariables>(MapWithLinkDocument, options);
        }
export type MapWithLinkQueryHookResult = ReturnType<typeof useMapWithLinkQuery>;
export type MapWithLinkLazyQueryHookResult = ReturnType<typeof useMapWithLinkLazyQuery>;
export type MapWithLinkQueryResult = Apollo.QueryResult<MapWithLinkQuery, MapWithLinkQueryVariables>;
export const SubscribeDocument = gql`
    mutation subscribe($email: String!) {
  subscribeToNewsletter(input: {email: $email}) {
    __typename
    ... on NewsletterSubscribeResult {
      status
    }
    ... on SubscribeToNewsletterErrors {
      validationEmail: email
      nonFieldErrors
    }
  }
}
    `;
export type SubscribeMutationFn = Apollo.MutationFunction<SubscribeMutation, SubscribeMutationVariables>;

/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeMutation, SubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeMutation, SubscribeMutationVariables>(SubscribeDocument, options);
      }
export type SubscribeMutationHookResult = ReturnType<typeof useSubscribeMutation>;
export type SubscribeMutationResult = Apollo.MutationResult<SubscribeMutation>;
export type SubscribeMutationOptions = Apollo.BaseMutationOptions<SubscribeMutation, SubscribeMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MySubmissionsDocument = gql`
    query MySubmissions($conference: String!) {
  me {
    id
    submissions(conference: $conference) {
      id
      title
      topic {
        id
        name
      }
      audienceLevel {
        id
        name
      }
      type {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useMySubmissionsQuery__
 *
 * To run a query within a React component, call `useMySubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySubmissionsQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useMySubmissionsQuery(baseOptions: Apollo.QueryHookOptions<MySubmissionsQuery, MySubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySubmissionsQuery, MySubmissionsQueryVariables>(MySubmissionsDocument, options);
      }
export function useMySubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySubmissionsQuery, MySubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySubmissionsQuery, MySubmissionsQueryVariables>(MySubmissionsDocument, options);
        }
export type MySubmissionsQueryHookResult = ReturnType<typeof useMySubmissionsQuery>;
export type MySubmissionsLazyQueryHookResult = ReturnType<typeof useMySubmissionsLazyQuery>;
export type MySubmissionsQueryResult = Apollo.QueryResult<MySubmissionsQuery, MySubmissionsQueryVariables>;
export const UpdateTicketDocument = gql`
    mutation UpdateTicket($conference: String!, $input: UpdateAttendeeTicketInput!, $language: String!) {
  __typename
  updateAttendeeTicket(
    conference: $conference
    input: $input
    language: $language
  ) {
    __typename
    ... on AttendeeTicket {
      id
      name
      email
      item {
        id
        name
        language
        description
        category
        questions {
          id
          answer {
            answer
            options
          }
          name
          options {
            id
            name
          }
        }
      }
    }
    ... on TicketReassigned {
      id
      email
    }
    ... on UpdateAttendeeTicketErrors {
      id
      errors {
        field
        message
      }
    }
  }
}
    `;
export type UpdateTicketMutationFn = Apollo.MutationFunction<UpdateTicketMutation, UpdateTicketMutationVariables>;

/**
 * __useUpdateTicketMutation__
 *
 * To run a mutation, you first call `useUpdateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketMutation, { data, loading, error }] = useUpdateTicketMutation({
 *   variables: {
 *      conference: // value for 'conference'
 *      input: // value for 'input'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateTicketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTicketMutation, UpdateTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTicketMutation, UpdateTicketMutationVariables>(UpdateTicketDocument, options);
      }
export type UpdateTicketMutationHookResult = ReturnType<typeof useUpdateTicketMutation>;
export type UpdateTicketMutationResult = Apollo.MutationResult<UpdateTicketMutation>;
export type UpdateTicketMutationOptions = Apollo.BaseMutationOptions<UpdateTicketMutation, UpdateTicketMutationVariables>;
export const SignupDocument = gql`
    mutation Signup($input: RegisterInput!) {
  register(input: $input) {
    __typename
    ... on RegisterSuccess {
      user {
        id
        email
        fullname
        name
      }
    }
    ... on EmailAlreadyUsed {
      message
    }
    ... on RegisterValidationError {
      errors {
        email {
          message
          type
        }
        password {
          message
          type
        }
      }
    }
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const SendCommentDocument = gql`
    mutation SendComment($input: SendSubmissionCommentInput!) {
  sendSubmissionComment(input: $input) {
    __typename
    ... on SubmissionComment {
      id
      submission {
        id
        comments {
          text
          id
          created
          author {
            name
          }
        }
      }
    }
    ... on SendSubmissionCommentErrors {
      validationText: text
      validationSubmission: submission
      nonFieldErrors
    }
  }
}
    `;
export type SendCommentMutationFn = Apollo.MutationFunction<SendCommentMutation, SendCommentMutationVariables>;

/**
 * __useSendCommentMutation__
 *
 * To run a mutation, you first call `useSendCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCommentMutation, { data, loading, error }] = useSendCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCommentMutation(baseOptions?: Apollo.MutationHookOptions<SendCommentMutation, SendCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCommentMutation, SendCommentMutationVariables>(SendCommentDocument, options);
      }
export type SendCommentMutationHookResult = ReturnType<typeof useSendCommentMutation>;
export type SendCommentMutationResult = Apollo.MutationResult<SendCommentMutation>;
export type SendCommentMutationOptions = Apollo.BaseMutationOptions<SendCommentMutation, SendCommentMutationVariables>;
export const SubmissionDocument = gql`
    query Submission($id: ID!) {
  submission(id: $id) {
    id
    title
    abstract
    elevatorPitch
    notes
    canEdit
    topic {
      id
      name
    }
    duration {
      id
      name
      duration
    }
    audienceLevel {
      id
      name
    }
    languages {
      id
      name
    }
    tags {
      id
      name
    }
    comments {
      id
      text
      created
      author {
        name
      }
    }
  }
}
    `;

/**
 * __useSubmissionQuery__
 *
 * To run a query within a React component, call `useSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmissionQuery(baseOptions: Apollo.QueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
      }
export function useSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
        }
export type SubmissionQueryHookResult = ReturnType<typeof useSubmissionQuery>;
export type SubmissionLazyQueryHookResult = ReturnType<typeof useSubmissionLazyQuery>;
export type SubmissionQueryResult = Apollo.QueryResult<SubmissionQuery, SubmissionQueryVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($conference: String!, $input: CreateOrderInput!) {
  createOrder(conference: $conference, input: $input) {
    ... on Error {
      message
    }
    ... on CreateOrderResult {
      paymentUrl
    }
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      conference: // value for 'conference'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const GetVoucherDocument = gql`
    query GetVoucher($conference: String!, $code: String!) {
  conference(code: $conference) {
    id
    voucher(code: $code) {
      id
      code
      value
      redeemed
      maxUsages
      priceMode
      items
      allItems
      variationId
      validUntil
    }
  }
}
    `;

/**
 * __useGetVoucherQuery__
 *
 * To run a query within a React component, call `useGetVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoucherQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetVoucherQuery(baseOptions: Apollo.QueryHookOptions<GetVoucherQuery, GetVoucherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoucherQuery, GetVoucherQueryVariables>(GetVoucherDocument, options);
      }
export function useGetVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoucherQuery, GetVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoucherQuery, GetVoucherQueryVariables>(GetVoucherDocument, options);
        }
export type GetVoucherQueryHookResult = ReturnType<typeof useGetVoucherQuery>;
export type GetVoucherLazyQueryHookResult = ReturnType<typeof useGetVoucherLazyQuery>;
export type GetVoucherQueryResult = Apollo.QueryResult<GetVoucherQuery, GetVoucherQueryVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries {
    code
    name
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  me {
    id
    name
    fullName
    email
    gender
    dateBirth
    country
    openToRecruiting
    openToNewsletter
    canEditSchedule
    isPythonItaliaMember
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const PageDocument = gql`
    query Page($code: String!, $slug: String!, $language: String!) {
  page(code: $code, slug: $slug) {
    id
    title(language: $language)
    content(language: $language)
    image
  }
}
    `;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      code: // value for 'code'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const AllPagesDocument = gql`
    query AllPages($code: String!, $language: String) {
  pages(code: $code) {
    id
    slug(language: $language)
  }
}
    `;

/**
 * __useAllPagesQuery__
 *
 * To run a query within a React component, call `useAllPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPagesQuery({
 *   variables: {
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAllPagesQuery(baseOptions: Apollo.QueryHookOptions<AllPagesQuery, AllPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPagesQuery, AllPagesQueryVariables>(AllPagesDocument, options);
      }
export function useAllPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPagesQuery, AllPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPagesQuery, AllPagesQueryVariables>(AllPagesDocument, options);
        }
export type AllPagesQueryHookResult = ReturnType<typeof useAllPagesQuery>;
export type AllPagesLazyQueryHookResult = ReturnType<typeof useAllPagesLazyQuery>;
export type AllPagesQueryResult = Apollo.QueryResult<AllPagesQuery, AllPagesQueryVariables>;
export const PostDocument = gql`
    query Post($slug: String!, $language: String!) {
  blogPost(slug: $slug) {
    id
    title(language: $language)
    content(language: $language)
    excerpt(language: $language)
    author {
      fullName
    }
    published
    image
  }
}
    `;

/**
 * __usePostQuery__
 *
 * To run a query within a React component, call `usePostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePostQuery(baseOptions: Apollo.QueryHookOptions<PostQuery, PostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostQuery, PostQueryVariables>(PostDocument, options);
      }
export function usePostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostQuery, PostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostQuery, PostQueryVariables>(PostDocument, options);
        }
export type PostQueryHookResult = ReturnType<typeof usePostQuery>;
export type PostLazyQueryHookResult = ReturnType<typeof usePostLazyQuery>;
export type PostQueryResult = Apollo.QueryResult<PostQuery, PostQueryVariables>;
export const BlogSocialCardDocument = gql`
    query BlogSocialCard($slug: String!, $language: String!) {
  blogPost(slug: $slug) {
    id
    title(language: $language)
    author {
      fullName
    }
  }
}
    `;

/**
 * __useBlogSocialCardQuery__
 *
 * To run a query within a React component, call `useBlogSocialCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogSocialCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogSocialCardQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useBlogSocialCardQuery(baseOptions: Apollo.QueryHookOptions<BlogSocialCardQuery, BlogSocialCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogSocialCardQuery, BlogSocialCardQueryVariables>(BlogSocialCardDocument, options);
      }
export function useBlogSocialCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogSocialCardQuery, BlogSocialCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogSocialCardQuery, BlogSocialCardQueryVariables>(BlogSocialCardDocument, options);
        }
export type BlogSocialCardQueryHookResult = ReturnType<typeof useBlogSocialCardQuery>;
export type BlogSocialCardLazyQueryHookResult = ReturnType<typeof useBlogSocialCardLazyQuery>;
export type BlogSocialCardQueryResult = Apollo.QueryResult<BlogSocialCardQuery, BlogSocialCardQueryVariables>;
export const BlogIndexDocument = gql`
    query BlogIndex($language: String!) {
  blogPosts {
    id
    slug
    title(language: $language)
    excerpt(language: $language)
  }
}
    `;

/**
 * __useBlogIndexQuery__
 *
 * To run a query within a React component, call `useBlogIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogIndexQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useBlogIndexQuery(baseOptions: Apollo.QueryHookOptions<BlogIndexQuery, BlogIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogIndexQuery, BlogIndexQueryVariables>(BlogIndexDocument, options);
      }
export function useBlogIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogIndexQuery, BlogIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogIndexQuery, BlogIndexQueryVariables>(BlogIndexDocument, options);
        }
export type BlogIndexQueryHookResult = ReturnType<typeof useBlogIndexQuery>;
export type BlogIndexLazyQueryHookResult = ReturnType<typeof useBlogIndexLazyQuery>;
export type BlogIndexQueryResult = Apollo.QueryResult<BlogIndexQuery, BlogIndexQueryVariables>;
export const IsCfpOpenDocument = gql`
    query IsCfpOpen($conference: String!) {
  conference(code: $conference) {
    id
    isCFPOpen
    cfpDeadline: deadline(type: "cfp") {
      id
      end
    }
  }
}
    `;

/**
 * __useIsCfpOpenQuery__
 *
 * To run a query within a React component, call `useIsCfpOpenQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCfpOpenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCfpOpenQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useIsCfpOpenQuery(baseOptions: Apollo.QueryHookOptions<IsCfpOpenQuery, IsCfpOpenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCfpOpenQuery, IsCfpOpenQueryVariables>(IsCfpOpenDocument, options);
      }
export function useIsCfpOpenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCfpOpenQuery, IsCfpOpenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCfpOpenQuery, IsCfpOpenQueryVariables>(IsCfpOpenDocument, options);
        }
export type IsCfpOpenQueryHookResult = ReturnType<typeof useIsCfpOpenQuery>;
export type IsCfpOpenLazyQueryHookResult = ReturnType<typeof useIsCfpOpenLazyQuery>;
export type IsCfpOpenQueryResult = Apollo.QueryResult<IsCfpOpenQuery, IsCfpOpenQueryVariables>;
export const MeSubmissionsDocument = gql`
    query MeSubmissions($conference: String!) {
  me {
    id
    submissions(conference: $conference) {
      id
      title
    }
  }
}
    `;

/**
 * __useMeSubmissionsQuery__
 *
 * To run a query within a React component, call `useMeSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeSubmissionsQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useMeSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<MeSubmissionsQuery, MeSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeSubmissionsQuery, MeSubmissionsQueryVariables>(MeSubmissionsDocument, options);
      }
export function useMeSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeSubmissionsQuery, MeSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeSubmissionsQuery, MeSubmissionsQueryVariables>(MeSubmissionsDocument, options);
        }
export type MeSubmissionsQueryHookResult = ReturnType<typeof useMeSubmissionsQuery>;
export type MeSubmissionsLazyQueryHookResult = ReturnType<typeof useMeSubmissionsLazyQuery>;
export type MeSubmissionsQueryResult = Apollo.QueryResult<MeSubmissionsQuery, MeSubmissionsQueryVariables>;
export const IndexPageDocument = gql`
    query IndexPage($code: String!, $language: String!) {
  blogPosts {
    id
    slug
    title(language: $language)
  }
  conference(code: $code) {
    id
    name(language: $language)
    introduction(language: $language)
    marquee: copy(key: "marquee", language: $language)
    introTitle: copy(key: "intro-title-1", language: $language)
    introText: copy(key: "intro-text-1", language: $language)
    homepageSection1Title: copy(key: "homepage-section1-title", language: $language)
    homepageSection1Subtitle: copy(
      key: "homepage-section1-subtitle"
      language: $language
    )
    homepageSection1Text: copy(key: "homepage-section1-text", language: $language)
    homepageSection1CTALink: copy(
      key: "homepage-section1-cta-link"
      language: $language
    )
    homepageSection1CTAText: copy(
      key: "homepage-section1-cta-text"
      language: $language
    )
    gettingThereText: copy(key: "getting-there-text", language: $language)
    isRunning
    map {
      id
      link
    }
    cfpDeadline: deadline(type: "cfp") {
      id
      start
      end
    }
    votingDeadline: deadline(type: "voting") {
      id
      start
      end
    }
    faqs {
      id
      question(language: $language)
      answer(language: $language)
    }
    events {
      id
      title
      locationName
      image
      start
    }
    sponsorsByLevel {
      level
      highlightColor
      sponsors {
        id
        name
        link
        image
      }
    }
  }
}
    `;

/**
 * __useIndexPageQuery__
 *
 * To run a query within a React component, call `useIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexPageQuery({
 *   variables: {
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useIndexPageQuery(baseOptions: Apollo.QueryHookOptions<IndexPageQuery, IndexPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndexPageQuery, IndexPageQueryVariables>(IndexPageDocument, options);
      }
export function useIndexPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndexPageQuery, IndexPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndexPageQuery, IndexPageQueryVariables>(IndexPageDocument, options);
        }
export type IndexPageQueryHookResult = ReturnType<typeof useIndexPageQuery>;
export type IndexPageLazyQueryHookResult = ReturnType<typeof useIndexPageLazyQuery>;
export type IndexPageQueryResult = Apollo.QueryResult<IndexPageQuery, IndexPageQueryVariables>;
export const AllJobListingsDocument = gql`
    query AllJobListings($language: String!) {
  jobListings {
    id
    slug(language: $language)
    title(language: $language)
    description(language: $language)
    applyUrl
    company
    companyLogo
  }
}
    `;

/**
 * __useAllJobListingsQuery__
 *
 * To run a query within a React component, call `useAllJobListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllJobListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllJobListingsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAllJobListingsQuery(baseOptions: Apollo.QueryHookOptions<AllJobListingsQuery, AllJobListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllJobListingsQuery, AllJobListingsQueryVariables>(AllJobListingsDocument, options);
      }
export function useAllJobListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllJobListingsQuery, AllJobListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllJobListingsQuery, AllJobListingsQueryVariables>(AllJobListingsDocument, options);
        }
export type AllJobListingsQueryHookResult = ReturnType<typeof useAllJobListingsQuery>;
export type AllJobListingsLazyQueryHookResult = ReturnType<typeof useAllJobListingsLazyQuery>;
export type AllJobListingsQueryResult = Apollo.QueryResult<AllJobListingsQuery, AllJobListingsQueryVariables>;
export const KeynoteSocialCardDocument = gql`
    query KeynoteSocialCard($conference: String!, $slug: String!, $language: String!) {
  conference(code: $conference) {
    id
    keynote(slug: $slug) {
      id
      title(language: $language)
      speakers {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useKeynoteSocialCardQuery__
 *
 * To run a query within a React component, call `useKeynoteSocialCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeynoteSocialCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeynoteSocialCardQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useKeynoteSocialCardQuery(baseOptions: Apollo.QueryHookOptions<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>(KeynoteSocialCardDocument, options);
      }
export function useKeynoteSocialCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>(KeynoteSocialCardDocument, options);
        }
export type KeynoteSocialCardQueryHookResult = ReturnType<typeof useKeynoteSocialCardQuery>;
export type KeynoteSocialCardLazyQueryHookResult = ReturnType<typeof useKeynoteSocialCardLazyQuery>;
export type KeynoteSocialCardQueryResult = Apollo.QueryResult<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>;
export const AllKeynotesDocument = gql`
    query AllKeynotes($conference: String!, $language: String!) {
  conference(code: $conference) {
    id
    keynotes {
      id
      slug(language: $language)
    }
  }
}
    `;

/**
 * __useAllKeynotesQuery__
 *
 * To run a query within a React component, call `useAllKeynotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllKeynotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllKeynotesQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAllKeynotesQuery(baseOptions: Apollo.QueryHookOptions<AllKeynotesQuery, AllKeynotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllKeynotesQuery, AllKeynotesQueryVariables>(AllKeynotesDocument, options);
      }
export function useAllKeynotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllKeynotesQuery, AllKeynotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllKeynotesQuery, AllKeynotesQueryVariables>(AllKeynotesDocument, options);
        }
export type AllKeynotesQueryHookResult = ReturnType<typeof useAllKeynotesQuery>;
export type AllKeynotesLazyQueryHookResult = ReturnType<typeof useAllKeynotesLazyQuery>;
export type AllKeynotesQueryResult = Apollo.QueryResult<AllKeynotesQuery, AllKeynotesQueryVariables>;
export const KeynoteDocument = gql`
    query Keynote($conference: String!, $slug: String!, $language: String!) {
  conference(code: $conference) {
    id
    keynote(slug: $slug) {
      id
      title(language: $language)
      description(language: $language)
      slug(language: $language)
      topic {
        id
        name
      }
      speakers {
        id
        name
        bio(language: $language)
        pronouns(language: $language)
        twitterHandle
        instagramHandle
        website
        photo
        highlightColor
      }
    }
  }
}
    `;

/**
 * __useKeynoteQuery__
 *
 * To run a query within a React component, call `useKeynoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeynoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeynoteQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useKeynoteQuery(baseOptions: Apollo.QueryHookOptions<KeynoteQuery, KeynoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeynoteQuery, KeynoteQueryVariables>(KeynoteDocument, options);
      }
export function useKeynoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeynoteQuery, KeynoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeynoteQuery, KeynoteQueryVariables>(KeynoteDocument, options);
        }
export type KeynoteQueryHookResult = ReturnType<typeof useKeynoteQuery>;
export type KeynoteLazyQueryHookResult = ReturnType<typeof useKeynoteLazyQuery>;
export type KeynoteQueryResult = Apollo.QueryResult<KeynoteQuery, KeynoteQueryVariables>;
export const KeynotesPageDocument = gql`
    query KeynotesPage($conference: String!, $language: String!) {
  conference(code: $conference) {
    id
    title: copy(key: "keynotes-title", language: $language)
    subtitle: copy(key: "keynotes-subtitle", language: $language)
    description: copy(key: "keynotes-description", language: $language)
    keynotes {
      id
      title(language: $language)
      slug(language: $language)
      speakers {
        id
        name
        photo
        highlightColor
      }
    }
  }
}
    `;

/**
 * __useKeynotesPageQuery__
 *
 * To run a query within a React component, call `useKeynotesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeynotesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeynotesPageQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useKeynotesPageQuery(baseOptions: Apollo.QueryHookOptions<KeynotesPageQuery, KeynotesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeynotesPageQuery, KeynotesPageQueryVariables>(KeynotesPageDocument, options);
      }
export function useKeynotesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeynotesPageQuery, KeynotesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeynotesPageQuery, KeynotesPageQueryVariables>(KeynotesPageDocument, options);
        }
export type KeynotesPageQueryHookResult = ReturnType<typeof useKeynotesPageQuery>;
export type KeynotesPageLazyQueryHookResult = ReturnType<typeof useKeynotesPageLazyQuery>;
export type KeynotesPageQueryResult = Apollo.QueryResult<KeynotesPageQuery, KeynotesPageQueryVariables>;
export const SocialLoginCheckDocument = gql`
    query SocialLoginCheck {
  me {
    email
  }
}
    `;

/**
 * __useSocialLoginCheckQuery__
 *
 * To run a query within a React component, call `useSocialLoginCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialLoginCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialLoginCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useSocialLoginCheckQuery(baseOptions?: Apollo.QueryHookOptions<SocialLoginCheckQuery, SocialLoginCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialLoginCheckQuery, SocialLoginCheckQueryVariables>(SocialLoginCheckDocument, options);
      }
export function useSocialLoginCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialLoginCheckQuery, SocialLoginCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialLoginCheckQuery, SocialLoginCheckQueryVariables>(SocialLoginCheckDocument, options);
        }
export type SocialLoginCheckQueryHookResult = ReturnType<typeof useSocialLoginCheckQuery>;
export type SocialLoginCheckLazyQueryHookResult = ReturnType<typeof useSocialLoginCheckLazyQuery>;
export type SocialLoginCheckQueryResult = Apollo.QueryResult<SocialLoginCheckQuery, SocialLoginCheckQueryVariables>;
export const OrderDocument = gql`
    query Order($conferenceCode: String!, $code: String!) {
  order(conferenceCode: $conferenceCode, code: $code) {
    code
    status
    url
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      conferenceCode: // value for 'conferenceCode'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const MyEditProfileDocument = gql`
    query MyEditProfile {
  me {
    email
    name
    fullName
    gender
    openToRecruiting
    openToNewsletter
    dateBirth
    country
  }
}
    `;

/**
 * __useMyEditProfileQuery__
 *
 * To run a query within a React component, call `useMyEditProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEditProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEditProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEditProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyEditProfileQuery, MyEditProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEditProfileQuery, MyEditProfileQueryVariables>(MyEditProfileDocument, options);
      }
export function useMyEditProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEditProfileQuery, MyEditProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEditProfileQuery, MyEditProfileQueryVariables>(MyEditProfileDocument, options);
        }
export type MyEditProfileQueryHookResult = ReturnType<typeof useMyEditProfileQuery>;
export type MyEditProfileLazyQueryHookResult = ReturnType<typeof useMyEditProfileLazyQuery>;
export type MyEditProfileQueryResult = Apollo.QueryResult<MyEditProfileQuery, MyEditProfileQueryVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    __typename
    ... on User {
      id
      name
      fullName
      gender
      openToRecruiting
      openToNewsletter
      country
      dateBirth
    }
    ... on UpdateProfileValidationError {
      errors {
        name {
          message
        }
        dateBirth {
          message
        }
        fullName {
          message
        }
        gender {
          message
        }
        name {
          message
        }
        openToRecruiting {
          message
        }
        openToNewsletter {
          message
        }
        country {
          message
        }
      }
    }
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const MyProfileDocument = gql`
    query MyProfile($conference: String!, $language: String!) {
  me {
    id
    name
    fullName
    email
    gender
    dateBirth
    country
    openToRecruiting
    openToNewsletter
    submissions(conference: $conference) {
      id
      title
      slug
    }
    orders(conference: $conference) {
      code
      status
      url
      total
    }
    tickets(conference: $conference, language: $language) {
      id
      name
      email
      item {
        id
        name
        language
        description
        category
        admission
        questions {
          id
          answer {
            answer
            options
          }
          name
          options {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
      }
export function useMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
        }
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const RankingDocument = gql`
    query Ranking($conference: String!, $topic: ID!) {
  conference(code: $conference) {
    id
    ranking(topic: $topic) {
      isPublic
      stats {
        id
        type
        value
        name
      }
      rankedSubmissions {
        rank
        score
        submission {
          ...submissionAccordion
          speaker {
            id
            fullName
          }
        }
      }
    }
  }
}
    ${SubmissionAccordionFragmentDoc}`;

/**
 * __useRankingQuery__
 *
 * To run a query within a React component, call `useRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankingQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useRankingQuery(baseOptions: Apollo.QueryHookOptions<RankingQuery, RankingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RankingQuery, RankingQueryVariables>(RankingDocument, options);
      }
export function useRankingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RankingQuery, RankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RankingQuery, RankingQueryVariables>(RankingDocument, options);
        }
export type RankingQueryHookResult = ReturnType<typeof useRankingQuery>;
export type RankingLazyQueryHookResult = ReturnType<typeof useRankingLazyQuery>;
export type RankingQueryResult = Apollo.QueryResult<RankingQuery, RankingQueryVariables>;
export const TopicsDocument = gql`
    query Topics($code: String!) {
  conference(code: $code) {
    id
    topics {
      id
      name
    }
  }
}
    `;

/**
 * __useTopicsQuery__
 *
 * To run a query within a React component, call `useTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTopicsQuery(baseOptions: Apollo.QueryHookOptions<TopicsQuery, TopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
      }
export function useTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicsQuery, TopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
        }
export type TopicsQueryHookResult = ReturnType<typeof useTopicsQuery>;
export type TopicsLazyQueryHookResult = ReturnType<typeof useTopicsLazyQuery>;
export type TopicsQueryResult = Apollo.QueryResult<TopicsQuery, TopicsQueryVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestResetPassword(email: $email) {
    __typename
    ... on OperationSuccess {
      ok
    }
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($token: String!, $password: String!) {
  resetPassword(input: {token: $token, newPassword: $password}) {
    __typename
    ... on OperationSuccess {
      ok
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const AddScheduleSlotDocument = gql`
    mutation AddScheduleSlot($code: ID!, $day: Date!, $duration: Int!) {
  addScheduleSlot(conference: $code, day: $day, duration: $duration) {
    ... on Day {
      day
      slots {
        ...ScheduleSlotFragment
      }
    }
  }
}
    ${ScheduleSlotFragmentFragmentDoc}`;
export type AddScheduleSlotMutationFn = Apollo.MutationFunction<AddScheduleSlotMutation, AddScheduleSlotMutationVariables>;

/**
 * __useAddScheduleSlotMutation__
 *
 * To run a mutation, you first call `useAddScheduleSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScheduleSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScheduleSlotMutation, { data, loading, error }] = useAddScheduleSlotMutation({
 *   variables: {
 *      code: // value for 'code'
 *      day: // value for 'day'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useAddScheduleSlotMutation(baseOptions?: Apollo.MutationHookOptions<AddScheduleSlotMutation, AddScheduleSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddScheduleSlotMutation, AddScheduleSlotMutationVariables>(AddScheduleSlotDocument, options);
      }
export type AddScheduleSlotMutationHookResult = ReturnType<typeof useAddScheduleSlotMutation>;
export type AddScheduleSlotMutationResult = Apollo.MutationResult<AddScheduleSlotMutation>;
export type AddScheduleSlotMutationOptions = Apollo.BaseMutationOptions<AddScheduleSlotMutation, AddScheduleSlotMutationVariables>;
export const GetScheduleInvitationDocument = gql`
    query GetScheduleInvitation($submissionId: ID!) {
  scheduleInvitation(submissionId: $submissionId) {
    id
    option
    notes
    submission {
      id
      title
    }
    dates {
      id
      start
      end
    }
  }
}
    `;

/**
 * __useGetScheduleInvitationQuery__
 *
 * To run a query within a React component, call `useGetScheduleInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleInvitationQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGetScheduleInvitationQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>(GetScheduleInvitationDocument, options);
      }
export function useGetScheduleInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>(GetScheduleInvitationDocument, options);
        }
export type GetScheduleInvitationQueryHookResult = ReturnType<typeof useGetScheduleInvitationQuery>;
export type GetScheduleInvitationLazyQueryHookResult = ReturnType<typeof useGetScheduleInvitationLazyQuery>;
export type GetScheduleInvitationQueryResult = Apollo.QueryResult<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>;
export const UpdateScheduleInvitationDocument = gql`
    mutation UpdateScheduleInvitation($input: UpdateScheduleInvitationInput!) {
  updateScheduleInvitation(input: $input) {
    __typename
    ... on ScheduleInvitation {
      id
      option
      notes
    }
    ... on ScheduleInvitationNotFound {
      message
    }
  }
}
    `;
export type UpdateScheduleInvitationMutationFn = Apollo.MutationFunction<UpdateScheduleInvitationMutation, UpdateScheduleInvitationMutationVariables>;

/**
 * __useUpdateScheduleInvitationMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleInvitationMutation, { data, loading, error }] = useUpdateScheduleInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleInvitationMutation, UpdateScheduleInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleInvitationMutation, UpdateScheduleInvitationMutationVariables>(UpdateScheduleInvitationDocument, options);
      }
export type UpdateScheduleInvitationMutationHookResult = ReturnType<typeof useUpdateScheduleInvitationMutation>;
export type UpdateScheduleInvitationMutationResult = Apollo.MutationResult<UpdateScheduleInvitationMutation>;
export type UpdateScheduleInvitationMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleInvitationMutation, UpdateScheduleInvitationMutationVariables>;
export const ScheduleDaysDocument = gql`
    query ScheduleDays($code: String!) {
  conference(code: $code) {
    id
    days {
      day
    }
  }
}
    `;

/**
 * __useScheduleDaysQuery__
 *
 * To run a query within a React component, call `useScheduleDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleDaysQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useScheduleDaysQuery(baseOptions: Apollo.QueryHookOptions<ScheduleDaysQuery, ScheduleDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleDaysQuery, ScheduleDaysQueryVariables>(ScheduleDaysDocument, options);
      }
export function useScheduleDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleDaysQuery, ScheduleDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleDaysQuery, ScheduleDaysQueryVariables>(ScheduleDaysDocument, options);
        }
export type ScheduleDaysQueryHookResult = ReturnType<typeof useScheduleDaysQuery>;
export type ScheduleDaysLazyQueryHookResult = ReturnType<typeof useScheduleDaysLazyQuery>;
export type ScheduleDaysQueryResult = Apollo.QueryResult<ScheduleDaysQuery, ScheduleDaysQueryVariables>;
export const ScheduleDocument = gql`
    query Schedule($code: String!, $fetchSubmissions: Boolean!) {
  conference(code: $code) {
    id
    timezone
    days {
      day
      rooms {
        id
        name
        type
      }
      slots {
        ...ScheduleSlotFragment
      }
    }
    submissions @include(if: $fetchSubmissions) {
      ...SubmissionFragment
    }
    keynotes @include(if: $fetchSubmissions) {
      ...KeynoteFragment
    }
    durations {
      id
      duration
      allowedSubmissionTypes {
        name
      }
    }
  }
}
    ${ScheduleSlotFragmentFragmentDoc}
${SubmissionFragmentFragmentDoc}
${KeynoteFragmentFragmentDoc}`;

/**
 * __useScheduleQuery__
 *
 * To run a query within a React component, call `useScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleQuery({
 *   variables: {
 *      code: // value for 'code'
 *      fetchSubmissions: // value for 'fetchSubmissions'
 *   },
 * });
 */
export function useScheduleQuery(baseOptions: Apollo.QueryHookOptions<ScheduleQuery, ScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleQuery, ScheduleQueryVariables>(ScheduleDocument, options);
      }
export function useScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleQuery, ScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleQuery, ScheduleQueryVariables>(ScheduleDocument, options);
        }
export type ScheduleQueryHookResult = ReturnType<typeof useScheduleQuery>;
export type ScheduleLazyQueryHookResult = ReturnType<typeof useScheduleLazyQuery>;
export type ScheduleQueryResult = Apollo.QueryResult<ScheduleQuery, ScheduleQueryVariables>;
export const UpdateOrCreateSlotItemDocument = gql`
    mutation UpdateOrCreateSlotItem($input: UpdateOrCreateSlotItemInput!) {
  updateOrCreateSlotItem(input: $input) {
    ... on UpdateOrCreateSlotItemResult {
      updatedSlots {
        ...ScheduleSlotFragment
      }
    }
  }
}
    ${ScheduleSlotFragmentFragmentDoc}`;
export type UpdateOrCreateSlotItemMutationFn = Apollo.MutationFunction<UpdateOrCreateSlotItemMutation, UpdateOrCreateSlotItemMutationVariables>;

/**
 * __useUpdateOrCreateSlotItemMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateSlotItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateSlotItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateSlotItemMutation, { data, loading, error }] = useUpdateOrCreateSlotItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreateSlotItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrCreateSlotItemMutation, UpdateOrCreateSlotItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrCreateSlotItemMutation, UpdateOrCreateSlotItemMutationVariables>(UpdateOrCreateSlotItemDocument, options);
      }
export type UpdateOrCreateSlotItemMutationHookResult = ReturnType<typeof useUpdateOrCreateSlotItemMutation>;
export type UpdateOrCreateSlotItemMutationResult = Apollo.MutationResult<UpdateOrCreateSlotItemMutation>;
export type UpdateOrCreateSlotItemMutationOptions = Apollo.BaseMutationOptions<UpdateOrCreateSlotItemMutation, UpdateOrCreateSlotItemMutationVariables>;
export const SocialCardDocument = gql`
    query SocialCard($code: String!) {
  conference(code: $code) {
    id
    start
    end
    name
  }
}
    `;

/**
 * __useSocialCardQuery__
 *
 * To run a query within a React component, call `useSocialCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCardQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSocialCardQuery(baseOptions: Apollo.QueryHookOptions<SocialCardQuery, SocialCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialCardQuery, SocialCardQueryVariables>(SocialCardDocument, options);
      }
export function useSocialCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialCardQuery, SocialCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialCardQuery, SocialCardQueryVariables>(SocialCardDocument, options);
        }
export type SocialCardQueryHookResult = ReturnType<typeof useSocialCardQuery>;
export type SocialCardLazyQueryHookResult = ReturnType<typeof useSocialCardLazyQuery>;
export type SocialCardQueryResult = Apollo.QueryResult<SocialCardQuery, SocialCardQueryVariables>;
export const StreamingDocument = gql`
    query Streaming($code: String!) {
  conference(code: $code) {
    id
    timezone
    days {
      day
      runningEvents {
        id
        slidoUrl
        duration
        title
        rooms {
          id
          name
        }
      }
      rooms {
        id
        name
        type
        streamingUrl
        slidoUrl
      }
    }
  }
}
    `;

/**
 * __useStreamingQuery__
 *
 * To run a query within a React component, call `useStreamingQuery` and pass it any options that fit your needs.
 * When your component renders, `useStreamingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamingQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useStreamingQuery(baseOptions: Apollo.QueryHookOptions<StreamingQuery, StreamingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StreamingQuery, StreamingQueryVariables>(StreamingDocument, options);
      }
export function useStreamingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StreamingQuery, StreamingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StreamingQuery, StreamingQueryVariables>(StreamingDocument, options);
        }
export type StreamingQueryHookResult = ReturnType<typeof useStreamingQuery>;
export type StreamingLazyQueryHookResult = ReturnType<typeof useStreamingLazyQuery>;
export type StreamingQueryResult = Apollo.QueryResult<StreamingQuery, StreamingQueryVariables>;
export const GetSubmissionDocument = gql`
    query GetSubmission($id: ID!) {
  submission(id: $id) {
    id
    title
    type {
      id
      name
    }
    abstract
    elevatorPitch
    notes
    canEdit
    speakerLevel
    previousTalkVideo
    topic {
      id
      name
    }
    duration {
      id
      name
    }
    audienceLevel {
      id
      name
    }
    languages {
      id
      code
      name
    }
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useGetSubmissionQuery__
 *
 * To run a query within a React component, call `useGetSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetSubmissionQuery, GetSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionQuery, GetSubmissionQueryVariables>(GetSubmissionDocument, options);
      }
export function useGetSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionQuery, GetSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionQuery, GetSubmissionQueryVariables>(GetSubmissionDocument, options);
        }
export type GetSubmissionQueryHookResult = ReturnType<typeof useGetSubmissionQuery>;
export type GetSubmissionLazyQueryHookResult = ReturnType<typeof useGetSubmissionLazyQuery>;
export type GetSubmissionQueryResult = Apollo.QueryResult<GetSubmissionQuery, GetSubmissionQueryVariables>;
export const UpdateSubmissionDocument = gql`
    mutation UpdateSubmission($input: UpdateSubmissionInput!) {
  mutationOp: updateSubmission(input: $input) {
    __typename
    ... on Submission {
      id
      title
      type {
        id
        name
      }
      abstract
      elevatorPitch
      notes
      speakerLevel
      previousTalkVideo
      topic {
        id
        name
      }
      duration {
        id
        name
      }
      audienceLevel {
        id
        name
      }
      languages {
        id
        code
        name
      }
      tags {
        id
        name
      }
    }
    ... on UpdateSubmissionErrors {
      validationTitle: title
      validationAbstract: abstract
      validationTopic: topic
      validationLanguages: languages
      validationType: type
      validationDuration: duration
      validationElevatorPitch: elevatorPitch
      validationNotes: notes
      validationAudienceLevel: audienceLevel
      validationTags: tags
      validationPreviousTalkVideo: previousTalkVideo
      validationSpeakerLevel: speakerLevel
      nonFieldErrors
    }
  }
}
    `;
export type UpdateSubmissionMutationFn = Apollo.MutationFunction<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>;

/**
 * __useUpdateSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubmissionMutation, { data, loading, error }] = useUpdateSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>(UpdateSubmissionDocument, options);
      }
export type UpdateSubmissionMutationHookResult = ReturnType<typeof useUpdateSubmissionMutation>;
export type UpdateSubmissionMutationResult = Apollo.MutationResult<UpdateSubmissionMutation>;
export type UpdateSubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>;
export const IsVotingClosedDocument = gql`
    query IsVotingClosed($conference: String!) {
  conference(code: $conference) {
    id
    isVotingClosed
  }
}
    `;

/**
 * __useIsVotingClosedQuery__
 *
 * To run a query within a React component, call `useIsVotingClosedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsVotingClosedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsVotingClosedQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useIsVotingClosedQuery(baseOptions: Apollo.QueryHookOptions<IsVotingClosedQuery, IsVotingClosedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsVotingClosedQuery, IsVotingClosedQueryVariables>(IsVotingClosedDocument, options);
      }
export function useIsVotingClosedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsVotingClosedQuery, IsVotingClosedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsVotingClosedQuery, IsVotingClosedQueryVariables>(IsVotingClosedDocument, options);
        }
export type IsVotingClosedQueryHookResult = ReturnType<typeof useIsVotingClosedQuery>;
export type IsVotingClosedLazyQueryHookResult = ReturnType<typeof useIsVotingClosedLazyQuery>;
export type IsVotingClosedQueryResult = Apollo.QueryResult<IsVotingClosedQuery, IsVotingClosedQueryVariables>;
export const BookScheduleItemDocument = gql`
    mutation BookScheduleItem($id: ID!) {
  bookScheduleItem(id: $id) {
    __typename
    ... on ScheduleItem {
      id
      userHasSpot
      spacesLeft
      hasSpacesLeft
    }
  }
}
    `;
export type BookScheduleItemMutationFn = Apollo.MutationFunction<BookScheduleItemMutation, BookScheduleItemMutationVariables>;

/**
 * __useBookScheduleItemMutation__
 *
 * To run a mutation, you first call `useBookScheduleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookScheduleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookScheduleItemMutation, { data, loading, error }] = useBookScheduleItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookScheduleItemMutation(baseOptions?: Apollo.MutationHookOptions<BookScheduleItemMutation, BookScheduleItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookScheduleItemMutation, BookScheduleItemMutationVariables>(BookScheduleItemDocument, options);
      }
export type BookScheduleItemMutationHookResult = ReturnType<typeof useBookScheduleItemMutation>;
export type BookScheduleItemMutationResult = Apollo.MutationResult<BookScheduleItemMutation>;
export type BookScheduleItemMutationOptions = Apollo.BaseMutationOptions<BookScheduleItemMutation, BookScheduleItemMutationVariables>;
export const CancelBookingScheduleItemDocument = gql`
    mutation CancelBookingScheduleItem($id: ID!) {
  cancelBookingScheduleItem(id: $id) {
    __typename
    ... on ScheduleItem {
      id
      userHasSpot
      hasSpacesLeft
      spacesLeft
    }
  }
}
    `;
export type CancelBookingScheduleItemMutationFn = Apollo.MutationFunction<CancelBookingScheduleItemMutation, CancelBookingScheduleItemMutationVariables>;

/**
 * __useCancelBookingScheduleItemMutation__
 *
 * To run a mutation, you first call `useCancelBookingScheduleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingScheduleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingScheduleItemMutation, { data, loading, error }] = useCancelBookingScheduleItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelBookingScheduleItemMutation(baseOptions?: Apollo.MutationHookOptions<CancelBookingScheduleItemMutation, CancelBookingScheduleItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBookingScheduleItemMutation, CancelBookingScheduleItemMutationVariables>(CancelBookingScheduleItemDocument, options);
      }
export type CancelBookingScheduleItemMutationHookResult = ReturnType<typeof useCancelBookingScheduleItemMutation>;
export type CancelBookingScheduleItemMutationResult = Apollo.MutationResult<CancelBookingScheduleItemMutation>;
export type CancelBookingScheduleItemMutationOptions = Apollo.BaseMutationOptions<CancelBookingScheduleItemMutation, CancelBookingScheduleItemMutationVariables>;
export const TalkSocialCardDocument = gql`
    query TalkSocialCard($slug: String!, $code: String!) {
  conference(code: $code) {
    id
    talk(slug: $slug) {
      id
      title
      speakers {
        __typename
        ... on ScheduleItemUser {
          id
          fullName
        }
        ... on ScheduleItemNamedUser {
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useTalkSocialCardQuery__
 *
 * To run a query within a React component, call `useTalkSocialCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalkSocialCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalkSocialCardQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTalkSocialCardQuery(baseOptions: Apollo.QueryHookOptions<TalkSocialCardQuery, TalkSocialCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalkSocialCardQuery, TalkSocialCardQueryVariables>(TalkSocialCardDocument, options);
      }
export function useTalkSocialCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalkSocialCardQuery, TalkSocialCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalkSocialCardQuery, TalkSocialCardQueryVariables>(TalkSocialCardDocument, options);
        }
export type TalkSocialCardQueryHookResult = ReturnType<typeof useTalkSocialCardQuery>;
export type TalkSocialCardLazyQueryHookResult = ReturnType<typeof useTalkSocialCardLazyQuery>;
export type TalkSocialCardQueryResult = Apollo.QueryResult<TalkSocialCardQuery, TalkSocialCardQueryVariables>;
export const TalkDocument = gql`
    query Talk($slug: String!, $code: String!) {
  conference(code: $code) {
    id
    talk(slug: $slug) {
      id
      title
      image
      highlightColor
      description
      hasLimitedCapacity
      spacesLeft
      hasSpacesLeft
      slidoUrl
      language {
        code
      }
      submission {
        id
        abstract
        elevatorPitch
        duration {
          id
          duration
        }
        audienceLevel {
          id
          name
        }
        topic {
          name
        }
      }
      speakers {
        ... on ScheduleItemUser {
          id
          fullName
        }
        ... on ScheduleItemNamedUser {
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useTalkQuery__
 *
 * To run a query within a React component, call `useTalkQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalkQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTalkQuery(baseOptions: Apollo.QueryHookOptions<TalkQuery, TalkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalkQuery, TalkQueryVariables>(TalkDocument, options);
      }
export function useTalkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalkQuery, TalkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalkQuery, TalkQueryVariables>(TalkDocument, options);
        }
export type TalkQueryHookResult = ReturnType<typeof useTalkQuery>;
export type TalkLazyQueryHookResult = ReturnType<typeof useTalkLazyQuery>;
export type TalkQueryResult = Apollo.QueryResult<TalkQuery, TalkQueryVariables>;
export const AllTalksDocument = gql`
    query AllTalks($code: String!) {
  conference(code: $code) {
    id
    talks {
      id
      slug
    }
  }
}
    `;

/**
 * __useAllTalksQuery__
 *
 * To run a query within a React component, call `useAllTalksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTalksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTalksQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAllTalksQuery(baseOptions: Apollo.QueryHookOptions<AllTalksQuery, AllTalksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTalksQuery, AllTalksQueryVariables>(AllTalksDocument, options);
      }
export function useAllTalksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTalksQuery, AllTalksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTalksQuery, AllTalksQueryVariables>(AllTalksDocument, options);
        }
export type AllTalksQueryHookResult = ReturnType<typeof useAllTalksQuery>;
export type AllTalksLazyQueryHookResult = ReturnType<typeof useAllTalksLazyQuery>;
export type AllTalksQueryResult = Apollo.QueryResult<AllTalksQuery, AllTalksQueryVariables>;
export const WorkshopBookingStateDocument = gql`
    query WorkshopBookingState($slug: String!, $code: String!) {
  conference(code: $code) {
    id
    talk(slug: $slug) {
      id
      hasLimitedCapacity
      spacesLeft
      hasSpacesLeft
      userHasSpot
    }
  }
}
    `;

/**
 * __useWorkshopBookingStateQuery__
 *
 * To run a query within a React component, call `useWorkshopBookingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkshopBookingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkshopBookingStateQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useWorkshopBookingStateQuery(baseOptions: Apollo.QueryHookOptions<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>(WorkshopBookingStateDocument, options);
      }
export function useWorkshopBookingStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>(WorkshopBookingStateDocument, options);
        }
export type WorkshopBookingStateQueryHookResult = ReturnType<typeof useWorkshopBookingStateQuery>;
export type WorkshopBookingStateLazyQueryHookResult = ReturnType<typeof useWorkshopBookingStateLazyQuery>;
export type WorkshopBookingStateQueryResult = Apollo.QueryResult<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>;
export const TicketsDocument = gql`
    query Tickets($conference: String!, $language: String!) {
  conference(code: $conference) {
    id
    start
    end
    pretixEventUrl
    tickets(language: $language) {
      id
      language
      name
      description
      defaultPrice
      availableUntil
      quantityLeft
      type
      category
      taxRate
      admission
      variations {
        id
        defaultPrice
        value
      }
      questions {
        id
        name
        required
        options {
          id
          name
        }
      }
    }
    hotelRooms {
      id
      name(language: $language)
      description(language: $language)
      price
      isSoldOut
      capacityLeft
    }
  }
}
    `;

/**
 * __useTicketsQuery__
 *
 * To run a query within a React component, call `useTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketsQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTicketsQuery(baseOptions: Apollo.QueryHookOptions<TicketsQuery, TicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketsQuery, TicketsQueryVariables>(TicketsDocument, options);
      }
export function useTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketsQuery, TicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketsQuery, TicketsQueryVariables>(TicketsDocument, options);
        }
export type TicketsQueryHookResult = ReturnType<typeof useTicketsQuery>;
export type TicketsLazyQueryHookResult = ReturnType<typeof useTicketsLazyQuery>;
export type TicketsQueryResult = Apollo.QueryResult<TicketsQuery, TicketsQueryVariables>;
export const SendVoteDocument = gql`
    mutation SendVote($input: SendVoteInput!) {
  sendVote(input: $input) {
    __typename
    ... on VoteType {
      id
      value
    }
    ... on SendVoteErrors {
      validationValue: value
      validationSubmission: submission
      nonFieldErrors
    }
  }
}
    `;
export type SendVoteMutationFn = Apollo.MutationFunction<SendVoteMutation, SendVoteMutationVariables>;

/**
 * __useSendVoteMutation__
 *
 * To run a mutation, you first call `useSendVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVoteMutation, { data, loading, error }] = useSendVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendVoteMutation(baseOptions?: Apollo.MutationHookOptions<SendVoteMutation, SendVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVoteMutation, SendVoteMutationVariables>(SendVoteDocument, options);
      }
export type SendVoteMutationHookResult = ReturnType<typeof useSendVoteMutation>;
export type SendVoteMutationResult = Apollo.MutationResult<SendVoteMutation>;
export type SendVoteMutationOptions = Apollo.BaseMutationOptions<SendVoteMutation, SendVoteMutationVariables>;
export const VotingSubmissionsDocument = gql`
    query VotingSubmissions($conference: String!, $after: String, $loadMore: Boolean!) {
  conference(code: $conference) @skip(if: $loadMore) {
    id
    isVotingOpen
    votingDeadline: deadline(type: "voting") {
      id
      end
    }
    topics {
      id
      name
    }
    languages {
      id
      name
      code
    }
  }
  submissions(code: $conference, after: $after) {
    ...submissionAccordion
  }
  submissionTags @skip(if: $loadMore) {
    id
    name
  }
}
    ${SubmissionAccordionFragmentDoc}`;

/**
 * __useVotingSubmissionsQuery__
 *
 * To run a query within a React component, call `useVotingSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVotingSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVotingSubmissionsQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      after: // value for 'after'
 *      loadMore: // value for 'loadMore'
 *   },
 * });
 */
export function useVotingSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>(VotingSubmissionsDocument, options);
      }
export function useVotingSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>(VotingSubmissionsDocument, options);
        }
export type VotingSubmissionsQueryHookResult = ReturnType<typeof useVotingSubmissionsQuery>;
export type VotingSubmissionsLazyQueryHookResult = ReturnType<typeof useVotingSubmissionsLazyQuery>;
export type VotingSubmissionsQueryResult = Apollo.QueryResult<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>;

  type MeSubmissionsQueryCacheReadOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: MeSubmissionsQueryVariables;
  }

  type MeSubmissionsQueryCacheWriteOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: MeSubmissionsQueryVariables;
    data: MeSubmissionsQuery;
  }

  export function readMeSubmissionsQueryCache<TMutation>(options: MeSubmissionsQueryCacheReadOptions<TMutation>) {
    return options.cache.readQuery<MeSubmissionsQuery, MeSubmissionsQueryVariables>({
      query: MeSubmissionsDocument,
      variables: options.variables,
    });
  }

  export function writeMeSubmissionsQueryCache<TMutation>(options: MeSubmissionsQueryCacheWriteOptions<TMutation>) {
    return options.cache.writeQuery<MeSubmissionsQuery, MeSubmissionsQueryVariables>({
      query: MeSubmissionsDocument,
      variables: options.variables,
      data: options.data,
    });
  }

  type VotingSubmissionsQueryCacheReadOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: VotingSubmissionsQueryVariables;
  }

  type VotingSubmissionsQueryCacheWriteOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: VotingSubmissionsQueryVariables;
    data: VotingSubmissionsQuery;
  }

  export function readVotingSubmissionsQueryCache<TMutation>(options: VotingSubmissionsQueryCacheReadOptions<TMutation>) {
    return options.cache.readQuery<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>({
      query: VotingSubmissionsDocument,
      variables: options.variables,
    });
  }

  export function writeVotingSubmissionsQueryCache<TMutation>(options: VotingSubmissionsQueryCacheWriteOptions<TMutation>) {
    return options.cache.writeQuery<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>({
      query: VotingSubmissionsDocument,
      variables: options.variables,
      data: options.data,
    });
  }


export async function queryCfpForm(client: ApolloClient<any>, variables?: CfpFormQueryVariables): Promise<CfpFormQueryResult> {
  // @ts-ignore
  return client.query({
    query: CfpFormDocument,
    variables,
  });
}


export async function queryFooter(client: ApolloClient<any>, variables?: FooterQueryVariables): Promise<FooterQueryResult> {
  // @ts-ignore
  return client.query({
    query: FooterDocument,
    variables,
  });
}


export async function queryGrantDeadline(client: ApolloClient<any>, variables?: GrantDeadlineQueryVariables): Promise<GrantDeadlineQueryResult> {
  // @ts-ignore
  return client.query({
    query: GrantDeadlineDocument,
    variables,
  });
}


export async function queryHeader(client: ApolloClient<any>, variables?: HeaderQueryVariables): Promise<HeaderQueryResult> {
  // @ts-ignore
  return client.query({
    query: HeaderDocument,
    variables,
  });
}


export async function queryTags(client: ApolloClient<any>, variables?: TagsQueryVariables): Promise<TagsQueryResult> {
  // @ts-ignore
  return client.query({
    query: TagsDocument,
    variables,
  });
}


export async function queryKeynotesSection(client: ApolloClient<any>, variables?: KeynotesSectionQueryVariables): Promise<KeynotesSectionQueryResult> {
  // @ts-ignore
  return client.query({
    query: KeynotesSectionDocument,
    variables,
  });
}


export async function queryMapWithLink(client: ApolloClient<any>, variables?: MapWithLinkQueryVariables): Promise<MapWithLinkQueryResult> {
  // @ts-ignore
  return client.query({
    query: MapWithLinkDocument,
    variables,
  });
}


export async function queryMySubmissions(client: ApolloClient<any>, variables?: MySubmissionsQueryVariables): Promise<MySubmissionsQueryResult> {
  // @ts-ignore
  return client.query({
    query: MySubmissionsDocument,
    variables,
  });
}


export async function querySubmission(client: ApolloClient<any>, variables?: SubmissionQueryVariables): Promise<SubmissionQueryResult> {
  // @ts-ignore
  return client.query({
    query: SubmissionDocument,
    variables,
  });
}


export async function queryGetVoucher(client: ApolloClient<any>, variables?: GetVoucherQueryVariables): Promise<GetVoucherQueryResult> {
  // @ts-ignore
  return client.query({
    query: GetVoucherDocument,
    variables,
  });
}


export async function queryCountries(client: ApolloClient<any>, variables?: CountriesQueryVariables): Promise<CountriesQueryResult> {
  // @ts-ignore
  return client.query({
    query: CountriesDocument,
    variables,
  });
}


export async function queryCurrentUser(client: ApolloClient<any>, variables?: CurrentUserQueryVariables): Promise<CurrentUserQueryResult> {
  // @ts-ignore
  return client.query({
    query: CurrentUserDocument,
    variables,
  });
}


export async function queryPage(client: ApolloClient<any>, variables?: PageQueryVariables): Promise<PageQueryResult> {
  // @ts-ignore
  return client.query({
    query: PageDocument,
    variables,
  });
}


export async function queryAllPages(client: ApolloClient<any>, variables?: AllPagesQueryVariables): Promise<AllPagesQueryResult> {
  // @ts-ignore
  return client.query({
    query: AllPagesDocument,
    variables,
  });
}


export async function queryPost(client: ApolloClient<any>, variables?: PostQueryVariables): Promise<PostQueryResult> {
  // @ts-ignore
  return client.query({
    query: PostDocument,
    variables,
  });
}


export async function queryBlogSocialCard(client: ApolloClient<any>, variables?: BlogSocialCardQueryVariables): Promise<BlogSocialCardQueryResult> {
  // @ts-ignore
  return client.query({
    query: BlogSocialCardDocument,
    variables,
  });
}


export async function queryBlogIndex(client: ApolloClient<any>, variables?: BlogIndexQueryVariables): Promise<BlogIndexQueryResult> {
  // @ts-ignore
  return client.query({
    query: BlogIndexDocument,
    variables,
  });
}


export async function queryIsCfpOpen(client: ApolloClient<any>, variables?: IsCfpOpenQueryVariables): Promise<IsCfpOpenQueryResult> {
  // @ts-ignore
  return client.query({
    query: IsCfpOpenDocument,
    variables,
  });
}


export async function queryMeSubmissions(client: ApolloClient<any>, variables?: MeSubmissionsQueryVariables): Promise<MeSubmissionsQueryResult> {
  // @ts-ignore
  return client.query({
    query: MeSubmissionsDocument,
    variables,
  });
}


export async function queryIndexPage(client: ApolloClient<any>, variables?: IndexPageQueryVariables): Promise<IndexPageQueryResult> {
  // @ts-ignore
  return client.query({
    query: IndexPageDocument,
    variables,
  });
}


export async function queryAllJobListings(client: ApolloClient<any>, variables?: AllJobListingsQueryVariables): Promise<AllJobListingsQueryResult> {
  // @ts-ignore
  return client.query({
    query: AllJobListingsDocument,
    variables,
  });
}


export async function queryKeynoteSocialCard(client: ApolloClient<any>, variables?: KeynoteSocialCardQueryVariables): Promise<KeynoteSocialCardQueryResult> {
  // @ts-ignore
  return client.query({
    query: KeynoteSocialCardDocument,
    variables,
  });
}


export async function queryAllKeynotes(client: ApolloClient<any>, variables?: AllKeynotesQueryVariables): Promise<AllKeynotesQueryResult> {
  // @ts-ignore
  return client.query({
    query: AllKeynotesDocument,
    variables,
  });
}


export async function queryKeynote(client: ApolloClient<any>, variables?: KeynoteQueryVariables): Promise<KeynoteQueryResult> {
  // @ts-ignore
  return client.query({
    query: KeynoteDocument,
    variables,
  });
}


export async function queryKeynotesPage(client: ApolloClient<any>, variables?: KeynotesPageQueryVariables): Promise<KeynotesPageQueryResult> {
  // @ts-ignore
  return client.query({
    query: KeynotesPageDocument,
    variables,
  });
}


export async function querySocialLoginCheck(client: ApolloClient<any>, variables?: SocialLoginCheckQueryVariables): Promise<SocialLoginCheckQueryResult> {
  // @ts-ignore
  return client.query({
    query: SocialLoginCheckDocument,
    variables,
  });
}


export async function queryOrder(client: ApolloClient<any>, variables?: OrderQueryVariables): Promise<OrderQueryResult> {
  // @ts-ignore
  return client.query({
    query: OrderDocument,
    variables,
  });
}


export async function queryMyEditProfile(client: ApolloClient<any>, variables?: MyEditProfileQueryVariables): Promise<MyEditProfileQueryResult> {
  // @ts-ignore
  return client.query({
    query: MyEditProfileDocument,
    variables,
  });
}


export async function queryMyProfile(client: ApolloClient<any>, variables?: MyProfileQueryVariables): Promise<MyProfileQueryResult> {
  // @ts-ignore
  return client.query({
    query: MyProfileDocument,
    variables,
  });
}


export async function queryRanking(client: ApolloClient<any>, variables?: RankingQueryVariables): Promise<RankingQueryResult> {
  // @ts-ignore
  return client.query({
    query: RankingDocument,
    variables,
  });
}


export async function queryTopics(client: ApolloClient<any>, variables?: TopicsQueryVariables): Promise<TopicsQueryResult> {
  // @ts-ignore
  return client.query({
    query: TopicsDocument,
    variables,
  });
}


export async function queryGetScheduleInvitation(client: ApolloClient<any>, variables?: GetScheduleInvitationQueryVariables): Promise<GetScheduleInvitationQueryResult> {
  // @ts-ignore
  return client.query({
    query: GetScheduleInvitationDocument,
    variables,
  });
}


export async function queryScheduleDays(client: ApolloClient<any>, variables?: ScheduleDaysQueryVariables): Promise<ScheduleDaysQueryResult> {
  // @ts-ignore
  return client.query({
    query: ScheduleDaysDocument,
    variables,
  });
}


export async function querySchedule(client: ApolloClient<any>, variables?: ScheduleQueryVariables): Promise<ScheduleQueryResult> {
  // @ts-ignore
  return client.query({
    query: ScheduleDocument,
    variables,
  });
}


export async function querySocialCard(client: ApolloClient<any>, variables?: SocialCardQueryVariables): Promise<SocialCardQueryResult> {
  // @ts-ignore
  return client.query({
    query: SocialCardDocument,
    variables,
  });
}


export async function queryStreaming(client: ApolloClient<any>, variables?: StreamingQueryVariables): Promise<StreamingQueryResult> {
  // @ts-ignore
  return client.query({
    query: StreamingDocument,
    variables,
  });
}


export async function queryGetSubmission(client: ApolloClient<any>, variables?: GetSubmissionQueryVariables): Promise<GetSubmissionQueryResult> {
  // @ts-ignore
  return client.query({
    query: GetSubmissionDocument,
    variables,
  });
}


export async function queryIsVotingClosed(client: ApolloClient<any>, variables?: IsVotingClosedQueryVariables): Promise<IsVotingClosedQueryResult> {
  // @ts-ignore
  return client.query({
    query: IsVotingClosedDocument,
    variables,
  });
}


export async function queryTalkSocialCard(client: ApolloClient<any>, variables?: TalkSocialCardQueryVariables): Promise<TalkSocialCardQueryResult> {
  // @ts-ignore
  return client.query({
    query: TalkSocialCardDocument,
    variables,
  });
}


export async function queryTalk(client: ApolloClient<any>, variables?: TalkQueryVariables): Promise<TalkQueryResult> {
  // @ts-ignore
  return client.query({
    query: TalkDocument,
    variables,
  });
}


export async function queryAllTalks(client: ApolloClient<any>, variables?: AllTalksQueryVariables): Promise<AllTalksQueryResult> {
  // @ts-ignore
  return client.query({
    query: AllTalksDocument,
    variables,
  });
}


export async function queryWorkshopBookingState(client: ApolloClient<any>, variables?: WorkshopBookingStateQueryVariables): Promise<WorkshopBookingStateQueryResult> {
  // @ts-ignore
  return client.query({
    query: WorkshopBookingStateDocument,
    variables,
  });
}


export async function queryTickets(client: ApolloClient<any>, variables?: TicketsQueryVariables): Promise<TicketsQueryResult> {
  // @ts-ignore
  return client.query({
    query: TicketsDocument,
    variables,
  });
}


export async function queryVotingSubmissions(client: ApolloClient<any>, variables?: VotingSubmissionsQueryVariables): Promise<VotingSubmissionsQueryResult> {
  // @ts-ignore
  return client.query({
    query: VotingSubmissionsDocument,
    variables,
  });
}

